export default {
  navbar_pages: {
    stats: 'Статистика',
    settings: 'Налаштування',
    team: 'Команда',
    menu: 'Меню',
    interfaces: 'Інтерфейси',
    systems: 'Системи',
    forms: 'Форми',
    integrations: 'Інтеграції',
    profile: 'Профіль',
    sms: 'SMS',

    systems_connected: 'Підключено',
    systems_available: 'Доступно',

    orders_panel: 'Панель замовлень',
    admin_panel: 'Адмін панель',

    telegram: 'Telegram',
    mobile_app: 'Mobile app',

    workspace: 'Заклад',
    workspace_add: 'Додати заклад',

    marketing: 'Маркетинг',
    marketplace: 'Marketplace',
  },
  navbar: {
    quickstart: 'Початок роботи',
    cafe: 'Головна',
    dashboard: 'Заклад',
    general: 'Загальне',
    stats: 'Статистика',
    menus: 'Страви',
    delivery: 'Delivery',
    preorder: 'Takeaway',
    inside: 'Inside',
    inside_lite: 'INSIDE lite',
    preview: 'Preview',
    reserve: 'Table booking',
    reserve_new: 'Reserve',
    cafe_settings: 'Налаштування',
    settings: 'Аккаунт',
    workers: 'Працівники',
    tools: 'Інструменти',
    marketing: 'Маркетинг',
    top_integrations: 'Інтеграції',
    pos_integrations: 'POS-інтеграції',
    integrations: 'Marketplace',
    rooms: 'Номера',
    stats: 'Статистика',
    reviews: 'Відгуки',
    workers: 'Персонал',
    loyalty: 'Програма лояльності',
    discounts: 'Акції',
    subscriptions: 'Платежі',
    marketplace: 'Marketplace QR',
    help: 'Завантажити інструкцію',
    logout: 'Вихід',
    billing: 'Оплата',
    setup: 'Як налаштувати систему?',
    qrstore: 'Сиcтеми QRWaiter',
    systems: 'QRStore',
    halls: 'Зали і столи',
    notifications: 'Сповіщення',
    clients_base: 'Клієнтська база',
    online_payment: 'Онлайн оплата',
    hotels: 'ROOMS',
    stickers_gallery: 'Галерея стікерів',
    orders_panel: 'Панель замовлень',
    client_orders_history: 'Історія замовлень',
    balance: 'Баланс',
    balance_table: 'Історія транзакцій',
    sms_settings: 'SMS-налаштування',
    checklists_reports: 'Звіти',
    working_schedule: 'Графік роботи',
    tips_settings: 'Чайові',

    nomenculature_packaging: 'Упаковка',
    checklists: 'Форми',

    sms_history: 'Історія SMS',

    chain_cafes: 'Заклади',
    chain_settings: 'Мережа',

    stats_orders: 'Загальна статистика',
    stats_guests: 'Гості',
    stats_finances: 'Фінанси',
    stats_tables: 'Зали і столи',
    stats_average: 'Середній чек',

    menu_app: 'Додаток з меню',

    taxes: 'Податки',

    //corporate admin panel
    corporate_cafes: 'Мої заклади',
    corporate_users: 'Доступ',
    corporate_stats: 'Статистика',

    chain: 'Мережа закладів',
    switch_cafe: 'Змінити заклад',

    support: 'Тех. підтримка',

    client_app: 'Налаштування',

    language: 'Мова',

    systems_in_your_plan: 'В вашому тарифі',
    systems_extra: 'Додатково',
  },
  navigation: {
    back: 'Назад',
  },
  confirm_register: {
    text: 'Для створення аккаунту придумайте надійний пароль входу.',
    password: 'Новий пароль:',
    continue: 'Продовжити',
    repeat_password: 'Повторіть новий пароль:',

    success: 'Ваш аккаунт створено. Тепер Ви можете увійти. Переадресація...',
    error: 'Сталася помилка:',

    pass_strength: {
      title: `Надійність паролю`,
      '0': 'Відсутня',
      '1': 'Ненадійний',
      '2': 'Середня',
      '3': 'Надійний',
      '4': 'Дуже надійний',
    },

    init_errors: {
      not_found: 'Невірне або вже використане посилання.',
      expired:
        'Срок дії посилання закінчився. Будь ласка, відправте нову заявку на реєстрацію.',
    },

    errors: {
      weak: 'Ваш пароль недостатньо надійний.',
      mismatch: 'Ваші паролі не співпадають.',
    },

    title: 'Підтвердження реєстрації',
    create_password: 'Створіть пароль',
    repeat_password: 'Повторіть пароль',
    create_acccount: 'Створити аккаунт',
  },
  confirm_employee: {
    desc:
      'Для створення аккаунту, придумайте надійний (від 6 символів) пароль.',
    pass: 'Введіть пароль',
    repeat: 'Повторіть новий пароль',
    btn: 'Активувати аккаунт',
    title: 'Підтвердження запрошення',
    hint: 'Створіть пароль для Вашого аккаунту QRWaiter',
  },
  login: {
    email: 'Введіть Вашу електронну пошту',
    password: 'Введіть Ваш пароль',
    forgot: 'Забули пароль?',
    register: 'Зареєструватись',
    title: 'Авторизація',

    two_factor_confirm:
      'На Ваш номер телефону {phone_mask} було відправлено одноразовий 6-значний код підтвердження.',

    login: 'Увійти',

    via_email: 'Через email',
    via_code: 'По коду',

    code_hint: 'Ви можете авторизуватись за допомогою Telegram бота',
    code_get: 'Натисніть "Отримати код для входу" в',
  },
  menu_manager: {
    title: 'Список меню',

    add_menu: '+ Додати меню',
    add_menu_ph: 'Назва нового меню',

    last_edited: 'Останнє редагування',
  },

  menus: {
    title: 'Редактор меню',
  },
  poptop: {
    title: `Поповнити рахунок`,
    sum: `Сума поповнення`,
    hint: `300 грн`,
    input: `Ввести суму`,
    hintb: `500 грн`,
    pay: `Оплатити`,
    back: `Повернутись`,
  },

  menu_settings: {
    title: 'Налаштування меню',
    name: `Назва`,
    name_hint: `Це технічна назва меню для Вас, і вона не показується клієнту.`,
    price: `Ціна`,
    weight: `Вага`,
    volume: `Об'єм`,
    portions_goods: `Порція`,
    weight_goods: `Ваговий товар`,
    semi_weight_goods: 'Вагова порція',

    portion_desc: 'При замоволенні вказується кількість порцій',
    weight_desc:
      'При замовленні вказується загальна вага, а не кількість порцй.',
    semi_weight_desc:
      'При замовленні вказується кількість порцій, але вагу кожної порції можна відкорегувати по факту прийняття замовлення (наприклад, стейки)',

    non_excise_goods: `Неакцизний товар`,
    add_ingredients: `Додати інгрідієнт`,
    input_ingredients: `Перерахуйте інгрідієнти (вони не показуються гостям в онлайн меню, а потрібні для роботи алгоритму смарт рекомендацій і для того, щоб відфільтрувати аллергенні страви для того чи іншого гостя)`,
    excise_goods: `Акцизний товар`,
    about: `Опис страви`,
    convert: `Конвертувати опис в інгредієнти`,
    edit: 'Редагувати вибране меню',
    edit_name: 'Редагувати назву',
    save_name: 'Зберегти назву',
    duplicate: 'Дублювати',
    delete: 'Видалити',
    done: `Готово`,
    hint: `Основне - сезон 2020`,
    hintb: `Бар меню`,
    webmenu: `Ця назва буде показуватись клієнту в онлайн меню.`,
    will_delete: `Вибраний додаток буде видалений з усіх страв, в якому він наявний. Ви впевнені?`,
    sale_hint: `Знижка на все меню`,
    sale_hintb: `Знижка буде застосована на всі страви та напої в цьому меню.`,
    preview: `Ви можете просканувати цей QR-код, та переглядати меню в режимі реального часу поки редагуєте його.`,
    poster: `Це меню імпортоване з системи Poster і не може бути видалене або дубльоване через редактор меню. Щоб видалити це меню, Вам потрібно вимкнути інтеграцію з системою Poster.`,
    sale: `Знижка`,
    recomendations: `Рекомендації`,
    additions: `Додатки`,
    addition: `Додаток`,
    ingredients: `Інгредієнти`,
    variants: `Варіанти`,
    DELETE: `ВИДАЛИТИ`,
    import_poster: `Імпортувати страву з Poster`,
    in_poster: `Відповідний товар в системі Poster`,
    poster_locked:
      'Ця страва імпортована з Poster, і тому змінити ціни і модифікатори можна тільки в Poster.',
    show_exclusives: 'Рекомендації в меню',
    show_exclusives_desc:
      'Окрема категорія рекомендацій, в якій відображаються найпопулярніші страви меню. Також цю категорію можна налаштувати в ручному режимі.',

    modes: {
      inside: 'Замовлення всередині закладу за допомогою QR-кодів',
      preorder:
        'Клієнти отримують можливість зробити замовлення наперед на певну дату і час, перейшовши за посиланням.',
      delivery:
        'Клієнти можуть замовити наперед з доставкою на вказану адресу і вказаний час.',
    },
    duplicate_suffix: '(копія)',

    confirm_delete_title: 'Видалення меню',
    confirm_delete: 'Ви впевнені, що хочете видалити меню "{title}"?',
    cannot_reverse: 'Повернути видалене меню буде неможливо.',
    example_menu: 'Приклад заповненого меню',

    select_mode: 'Оберіть, в яких системах повинне працювати данне меню.',
    no_modes:
      'У Вас не ввімкнена жодна система. Для підключення системи перейдіть в розділ "Системи QRWaiter"',
    preview_title: 'Попередній перегляд меню',

    systems: 'Системи',
  },

  menu_tag: {
    title: 'Назва меню для гостей',
    ph: 'Бар меню',
    desc:
      'Коли у Вас для однієї системи увімкнено декілька різних меню, то гості можуть між ними перемикатись. Також вони бачать назву кожного меню. Вкажіть назву, яку будуть бачити Ваші гості (наприклад, "Бар меню")',
  },

  menu_editor: {
    back: 'Назад',
    variants: `Перерахуйте варіанти`,
    new_variant: `Новий варіант`,
    variant: `Варіант`,
    gram: `Грамаж`,
    liter: `Літраж`,
    price: `Ціна`,
    additions: `Перерахуйте додатки`,
    addition: `Додаток`,
    new_addition: `Новий додаток`,
    languages: 'Доступні мови:',
    confirm_language_delete: 'Ви впевнені, що хочете видалити цю мову меню?',
  },

  menu_content_type: {
    title: 'Тип меню',
    dishes: 'Страви',
    drinks: 'Напої',
    description:
      'В залежності від обраного типу на стравах будуть змінюватись одиниці вимірювання (грами або літри)',
  },

  menu_payment: {
    title: 'Рахунок для онлайн оплати',
    choose_ph: '- оберіть рахунок -',
    warning:
      'Онлайн оплата в цьому меню недоступна. Будь ласка, оберіть рахунок для онлайн оплати.',
    desc:
      'Оберіть рахунок, на який повинні надходити кошти від замовлень страв та товарів з цього меню.',
  },

  category_list: {
    title: 'Категорії',

    add_category: '+ Додати категорію',
    add_category_ph: 'Назва категорії',

    new_category_ph: 'Нова категорія',

    edit: 'Редагувати',
    rearrange: 'Впорядкувати',
    done: 'Готово',

    delete: 'Видалити категорію',
    confirm_delete:
      'Ви впевнені що хочете видалити категорію "{name}"? Ця дія видалить всі страви, наявні в цій категорії.',
  },

  dish_list: {
    title: 'Страви',
    add_dish: '+ Додати страву',
    out_of_stock: 'Не в наявності',

    rearrange: 'Впорядкувати',
    availability: 'Наявність',

    invalid_dish: `Не заповнені обов'язкові поля`,
  },

  dish_tab: {
    title: 'Страва',

    edit: 'Редагувати',
    delete: 'Видалити',
    done: 'Готово',

    confirm_delete_title: 'Видалення страви',
    confirm_delete: 'Ви впенвнені, що хочете видалити страву "{name}"?',
  },

  confirm_modal: {
    confirm: 'Так',
    cancel: 'Ні',
    default: 'Ви впевнені?',
  },

  image_uploader: {
    default: 'ЗАВАНТАЖИТИ',
    edit: 'РЕДАГУВАТИ',
    delete: 'ВИДАЛИТИ',
    default_busy: 'ЗАЧЕКАЙТЕ...',

    type_logo: 'Логотип',
    type_cover: 'Обкладинка',

    size: 'Розмір',
    format: 'Формат',
  },

  dish_settings: {
    title: 'Налаштування страви',
    excise_desc:
      'Вкажіть чи є товар акцизним. Акцизні товари не будуть відображаися в меню для осіб, яким менше 18 років.',
    weighted_desc:
      'Від цього налаштування залежить, як буде розраховуватись вартість упаковки',
    in_stock: 'Товар в наявності',
    stock_disabled:
      'Ви не можете змінити наявність цієї страви, оскільки увімкнена синхронізація залишків на складах з POS-системою.',
    preset: 'Тип',
    preset_desc:
      'Для пришвидшення введення меню Ви можете обрати тип страви і відповідні групи модифікаторів будуть створені автоматично.',
    preset_dish: 'Звичайна страва',
    preset_pizza: 'Піца',
    waiting_time_ph: 'Орієнтовний час приготування (хв)',

    sync_warn:
      'Це меню було відредаговано з іншого пристрою.<br>При роботі з редактором меню, будь ласка, працюйте в одній вкладці браузера та не дублюйте їх.',

    long_units: {
      l: 'Літри',
      g: 'Грами',
      cm: 'Сантиметри',
      ml: 'Мілілітри',
      kg: 'Кілограми',
    },

    limits: 'Обмеження',
    weight_type: 'Тип зважування',

    status_saved: 'Зміни збережено.',
    status_saving: 'Збереження змін...',
    status_error: `Страва не показується в меню, оскільки не заповнені обов'язкові поля (назва, ціна).`,

    enable_modes_description:
      'Оберіть, в яких системах повинна відображатись данна страва.',

    service_duration: 'Тривалість обслуговування',
    service_break_time: 'Час на підготовку послуги',
  },

  transfer_dish: {
    title: 'Переміщення страви',
    action: 'Перемістити',
    select_menu: 'оберіть меню',
    select_category: 'оберіть категорію',
    cancel: 'Скасувати',
    confirm: 'Перемістити',
  },

  modificators_settings: {
    title: 'Налаштування модифікаторів',
    variant_name: 'Варіанти',
    modif_name: 'Додатки',
    type_hint: 'Тип',
    name_hint: 'Назва набору модифікаторів',
    selection_hint: 'Мультивибір',
    placeholder_optional: 'Ви можете залишити це поле пустим',
    placeholder_required: 'Введіть назву групи модифікаторів',
    single_select: 'Гість може обрати тільки 1 варіант із списку',
    multi_select: 'Гість може обрати декілька варіантів із списку',
    single_select_limited: 'Вибір до {max_count} варіантів з списку',
    multi_select_limited: 'Вибір до {max_count} додатків з списку',

    group: 'Група модифікаторів',

    allow_max_count: 'Дозволяти вибирати декілька варіантів',
    max_count_placeholder: 'Вкажіть максимальну кількість',

    item_placeholder: 'Назва модифікатора',
    placeholder_dish: 'Назва модифікатора',
    placeholder_pizza: 'Розмір піци (см)',

    dependencies_title: 'Залежності',
    dependencies_btn: 'Налаштувати залежності',

    name_ph: 'Модифікатор',
    visible: 'Видимий',

    link_btn: `Прив'язати до іншої групи`,

    move_up: 'Перемістити вгору',
    move_down: 'Перемістити вниз',

    integration: 'Інтеграція',

    add_modificator: 'Додати модифікатор',
    add_group: 'Додати набір модифікаторів',
    remove_group: 'Видалити набір модифікаторів',

    max_count_variants_hint: 'Вибір декількох модифікаторів',
    max_count_additions_hint: 'Обмежити кількість модифікаторів для вибору',

    confirm_remove: 'Ви впевнені що хочете видалити цей набір модифікаторів?',
    confirm_remove_item: 'Ви впевнені, що хочете видалити цей модифікатор?',

    locked_changes: 'Заблоковані зміни',

    dependency: '',
    dependencies_info_tip:
      'Ви можете привязати цю групу до обраних модифікаторів іншої групи.',
    dependency_self_item:
      'Ви можете привязати цей модифікатор до іншої групи модифікаторів. Вона буде показуватись у випадку якщо цей модифікатор буде вибраний',

    manage: 'Керувати',
    setup: 'Налаштувати',

    linked_tip_title: 'Залежні модифікатори',
    linked_tip_desc:
      'Ця група модифікаторів привязана до іншого модифікатора. Це значить, що вона буде доступна для вибору тільки якщо хоча б один з наступних модифікаторів буде обрано:',

    cant_delete_group: `Ця група модифікаторів є обов'язковою в POS системі і вона необхідна для корректної роботи інтеграції, тому її налаштування неможливо редагувати.`,
  },

  add_modificator_group_modal: {
    add_new: 'Створити новий набір модифікаторів',
    add_existing: 'Додати існуючий набір',
    add_existing_desc:
      'Оберіть із списку, який набір модифікаторів Ви бажаєте додати до цієї страви.',
    merge: 'Прив`язати',
    confirm: 'Додати набір',
    cancel: 'Скасувати',
    select_ph: 'Оберіть набір',
  },

  modificators_merge_modal: {
    title: 'Прив’язка набору модифікаторів',
    info1:
      'Ви можете побудувати залежність між групами модифікаторів. При виборі певного модифікатору в одній групі, гість буде бачити цей набір модифікаторів.',
    info2:
      'Оберіть модифікатор, до якого повинна бути прив’язана дана група модифікаторів',
    group_ph: 'Група модифікаторів',
    mod_ph: 'Модифікатор',
  },

  schedule: {
    days: {
      mon: 'Понеділок',
      tue: 'Вівторок',
      wed: 'Середа',
      thu: 'Четвер',
      fri: `П'ятниця`,
      sat: `Субота`,
      sun: 'Неділя',
    },

    general_title: 'Загальний графік роботи',
    general_desc: 'Загальний графік роботи для всіх систем по замовчуванню',

    specific_title: 'Графік роботи {mode}',
    specific_desc:
      'Цей графік роботи буде застосовуватись замість загальних налаштувань',

    mode_title: 'Індивідуальний графік роботи',
    menu_title: 'Індивідуальний графік роботи меню',

    from: 'Від',
    to: 'До',

    mode_desc:
      'Якщо цей параметр вимкнено, то система {mode} працює за загальним графіком роботи закладу. Ви можете налаштувати для неї індивідуальний графік роботи, який не буде залежати від загального.',

    using_default:
      'Для цієї системи використовується загальний графік роботи закладу.',

    menu_text:
      'Ви можете налаштовувати графік роботи меню. Наприклад, якщо Ваш заклад працює до 23:00, а кухня лише до 21:00',
  },

  nouns: {
    dishes: 'страв',
    categories: 'категорій',
    modificators: 'додатків',
  },
  units: {
    units: `Одиниця вимірювання`,
    l: 'л.',
    g: 'г.',
    kg: 'кг.',
    ml: 'мл.',
    mins: 'хв.',
    hours: 'год.',
    cm: 'см.',
    meters: 'м.',
    days: 'дн.',
  },
  error_codes: {
    subscription_form_failed: 'Не вдалось згенерувати форму оплати. ',
    cafe_save: `Не вдалось зберегти налаштування закладу. Будь ласка, спробуйте пізніше або зв'яжіться з тех. підтримкою.`,
    menu_save: `Не вдалось зберегти меню. `,
    promocode_wrong: 'Промокод невірний.',
    packaging_empty: 'Вкажіть хоча б 1 налаштування упаковки.',
    warehouses_error:
      'Не вдалось завантажити список доступних відділень "Нова Пошта". Будь ласка, оновіть сторінку або спробуйте пізніше.',
    shipment_failed: 'Не вдалось розмістити Ваше замовлення.',
    billing_fetch: 'Не вдалось завантажити інформацію про баланс.',
    stats_failed: 'Не вдалось завантажити статистику. ',
    poster_error: `Помилка інтеграції з системою Poster. Будь ласка, спробуйте пізніше або зв'яжіться з тех. підтримкою.`,
    reviews_error: 'Помилка завантаження відгуків. ',
    subscription_error: 'Помилка завантаження підписок. ',
    menu_sync:
      'Необхідна синхронізація меню - зачекайте, будь ласка, сторінку буде перезавантажено...',
    referrals_error: 'Помилка завантаження даних про маркетинг. ',

    auth_error: 'Помилка авторизації. ',
    menu_invalid: `Для збереження меню необіхдно заповнити всі обов'язкові поля, такі як назви та ціни`,
    subscription_setup_mode:
      'Для оформлення підписки необхідно повністю налаштувати обрану систему.',
    currency_error: 'Сталася помилка завантаження валюти. ',
    menu_schedule:
      'Графік роботи меню не повинен виходити за рамки графіка роботи закладу.',
    reserve_tables:
      'Для збереження налаштувань залів і столів RESERVE, оберіть хоча б 1 стіл в якості столика для бронювань.',

    employees_error: 'Помилка оновлення даних доступу. ',
    payment_error: 'Помилка сервісу онлайн оплати. ',
    promocodes_error: 'Помилка сервісу промокодів. ',

    superbilling_error: 'Помилка сервісу оплати',

    waiter_pin_exists:
      'Офіціант з таким PIN-кодом вже існує. Будь ласка, введіть інший PIN код',
  },

  order_stickers: {
    templates: {
      basic: 'Сучасний',
      classic: 'Класичний',
      hype: 'Молодіжний',
    },
  },

  mode_settings: {
    enable: 'Система',
    menu: 'Меню',
    payment: 'Способи оплати',
    waiters: 'Персонал',
    stickers: 'Стікери',
    schedule: 'Графік роботи',
    tables: 'Зали і столи',
    subscription: 'Підписка',
    geolocation: 'Зони доставки',
    notifications: 'Сповіщення',
    address: 'Адреса закладу',
    total: '',

    required: `Обов'язкові налаштування`,
    optional: 'Додаткові налаштування',
  },
  mode_settings_hints: {
    enable: 'Увімкніть систему',
    menu: 'Увімкніть цю систему хоча б для одного меню',
    payment: 'Налаштуйте доступні методи оплати для цієї системи.',
    waiters: 'Налаштуйте список персоналу для прийому замовлень.',
    stickers: 'Активуйте стікери з QR-кодами.',
    schedule: 'Налаштуйте графік роботи закладу.',
    tables: 'Налаштуйте зали і столи.',
    subscription: 'Оформіть підписку для цієї системи',
    geolocation: 'Вкажіть зони, в яких працює Ваша доставка',
    notifications: 'Авторизуйтесь в черзі замовлень.',
    address: 'Вкажіть корректну адресу закладу.',
    total: '',
  },
  stats: {
    title: `Статистика`,
    loading: `Завантаження...`,
    empty_desc:
      'Тут буде показуватись статистика по Вашому закладу. Для формування статистики необхідно, щоб Ваш заклад пропрацював в системі QRWaiter щонайменше 1 тиждень.',
    general: `Загальна`,
    currency: {
      uah: `UAH`,
      uahn: `грн`,
    },
    clients: {
      title: `Клієнтська база`,
      search: `Пошук...`,
      export: `Експортувати`,
      import: `Імпортувати`,
      name: `Ім'я`,
      phone: `Номер телефону`,
      address: `Адреса`,
      bonus: `Бонусний рахунок`,
      averange: `Середній чек`,
      first: `Замовили вперше:`,
      returning: `Замовили повторно:`,
      new: `Нові`,
      old: `Старі`,
      choose_file_type: 'Оберіть тип файлу для експорту:',
    },
    import: {
      file: `Оберіть файл для імпорту бази клієнтів.`,
      csv: `Підтримується формат CSV.`,
      max_size: `Максимальний об'єм файлу: 3 МБ`,
      must_consist_of: `Файл має складатись з трьох стовпців: Name, Phone і Address.`,
      example: `Переглянути приклад файлу для імпорту.`,
      unable_to_import: `Не вдалось імпортувати файл клієнтської бази. Переконайтесь, що файл правильного формату.`,
      choose: `Обрати файл...`,
      close: `Закрити`,
    },
    top_dishes: 'Топ страв',
    top_waiters: 'Топ офіціантів',
    top_clients: 'Топ клієнтів',
    since: `since last month`,
    income_month: `Прибуток міс.`,
    averange: `Середній чек`,
    orders_month: `Замовлення міс.`,
    orders: `замовлень`,
    rate: `Співвідношення систем`,
    data_for: `Дані за`,
    income: `Прибуток`,
    income_for: `Дохід за період`,
    averange_for: `Середній чек за період`,
    orders_for: `Замовлень за період`,
    visits_for: `Відвідувань за період`,
    views: `Перегляди меню`,
    view: `Перегляди`,
    order: `Замовлень`,
    amount: `шт.`,
    popular: `Найпопулярніші страви`,
    activity: `Активність`,
    guests: `Гості`,
    week: `тиждень `,
    two_weeks: `2 тижні `,
    month: `місяць `,
  },
  general: {
    cafe: {
      about: `Опис закладу`,
      address: `адреса:`,
      price_policy: `Цінова політика:`,
      panelid: `ID Панелі:`,
      panel: `Панель замовлень:`,
      menu: 'Меню',
      settings: `Налаштування`,
      no_subscriptions:
        'Тут будуть показуватись активні підписки, проте зараз жодна з систем QRWaiter не ввімкнена.',
    },
    balance: {
      marketadd: `Поповнити`,
      marketsettings: `Налаштування`,
    },
    cards: {
      inside_about_pro: `Цифрове меню всередині закладу з можливістю приймати замовлення через нього.`,
      inside_about: `Цифрове меню всередні закладу`,
      preorder_about: `Приймайте замовлення їжі "з собою".`,
      delivery_about: `Приймайте замовлення на доставку.`,
      reserve_about: `Приймайте замовлення на бронювання столику.`,
      deposit: `- можилвість внести депозит (онлайн)`,
      info_reserve: `- можилвість залишити детальну інформацію про гостя`,
      marketplace_about: `Ви також можете приймати замовлення та збільшувати свою клієнтську базу через маркетплейс QRWaiter.`,
      marketplace_settings: `Оберіть системи, які Ви хочете відображати на маркетплейсі:`,
      hotels_about:
        'Система для отелів, яка допоможе офицрувати замовлення їжі, напоїв та навіть послуг рум-сервісу.',
      menu: `+ Цифрове меню для гостей`,
      pt1: `- онлайн оплата`,
      pt2: `- можливість залишити чайові`,
      pt3: `- послуги`,
      pt4: `- мультимовність`,
      pt5: `- смарт-рекомендації`,
      application: `+ Додаток прийому замовлень для персоналу`,
      pro_pt1: `- Live CRM`,
      pro_pt2: `- Автоматичні нагадування`,
      pro_pt3: `- Трекери часу`,
      pro_pt4: `- Персональний кабінет кожного працівника`,
      qr: `Для користування необхідно замовити QR-стікери.`,
      link: `Для системи використовується посилання на онлайн-меню. Посилання можна розмістити в соц. мережах.`,
      disconnect: `Відключити`,
      connect: `Підключити`,
      settings: `Налаштування`,
      month: 'міс.',
    },
    daily_summary: {
      new_clients: 'Нових клієнтів за останній місяць',
      new_orders: 'Замовлення за останній місяць',
    },
  },
  marketplace: {
    bonus_hint: `Ви можете давати своїм гостям бонуси від замовлень у Вашому закладі. Як тільки гість накопичить достатньо бонусів - він зможе ними розрахуватись за замовлення. А Ваш персонал та Вас буде сповіщено про "бонусний розрахунок"`,
    bonus_amount: `Вкажіть розмір бонусу`,
    loyalty_program: `Включаючи програму лояльності Ви автоматично погоджуєтесь з політикою маркетплейсу QRWaiter.`,
    no_bonus: `Виберіть розмір бонусу`,
    loyalty: `Програма лояльності`,
    add_balance: `Поповнити`,
    remind_on_low: `Нагадувати про поповнення при досягненні балансу менше`,
    flavors_title: 'Категорії маркетплейсу QR',
    balance_title: 'Баланс',
    balance_debt:
      'Допустимий баланс -30 грн. При перевищенні ліміту Ваш заклад не буде відображатись в маркетплейсі QRWaiter.',
    policy_agree:
      'Обираючи хоча б одну з систем, Ви автоматично погоджуєтесь з політикою маркетплейсу QRWaiter.',
    flavors_desc: `Оберіть, до яких категорій належить Ваш заклад. Пам'ятайте, що сортування закладів в макретплейсі по категоріям допомагає Вашим гостями швидше знайти необхідний заклад.`,
    flavors_one:
      'Заклад буде відображатись в маркетплейсі QR тільки після того як буде обрана хоча б 1 категорія',
    flavors_not_found:
      'Якщо Ви не змогли знайти підходящої категорії для Вашого закладу - зверніться до',
    flavors_support: 'тех. підтримки QRWaiter.',
    app_desc:
      'Відскануйте QR-код з мобільного пристрою (через камеру) або натисніть на іконку магазину додатків, щоб завантажити додаток.',

    land_title:
      'Отримуйте ще більше замовлень за допомогою маркетплейсу QRWaiter™',
    land_connect: 'Подати заявку',
    download_btn: 'Завантажити додаток',
  },
  marketplace_policy: {
    title: 'Політика маркетплейсу QR',
    agreed: 'Я прочитав та погоджуюсь',
    agreed_link: 'з політикою маркетплейсу QR',
    link:
      'Для того, щоб Ваш заклад показувався в маркетплейсі QRWaiter, Ви маєте погодитись з його політикою.',
  },
  settings_cafe: {
    title: `Загальні налаштування закладу`,
    demo_warning:
      '! Посилання працює в демо-режимі. Замовлення не враховуються в статистику. Щоб вимкнути демо режим, оплатіть підписку !',
    cafe_info: {
      info: `Загальна інформація`,
      name: `Назва закладу`,
      type: `Опис закладу`,
      price_policy: `Цінова політика`,
      option: `Цінова політика`,
    },
    contacts: {
      title: `Контакти закладу в меню`,
      phone: `Номер телефону`,
      address: `Адреса закладу`,
      desc:
        'Ви можете розмістити контакти закладу. Ваші гості зможуть побачити їх в меню.',
    },
    online_menu: {
      title: `Посилання на онлайн меню`,
      chain_title: 'Посилання мережі',
      copy_btn: 'Копіювати посилання',
      description:
        'Дане посилання Ви можете розмістити в своїх соц. мережах. За даним посиланням доступний функціонал TAKEAWAY, DELIVERY, RESERVE.',
      input_link: `Вкажіть посилання, за яким можна буде знайти Ваше онлайн-меню. Також Ви можете використовувати це посилання у Ваших соц. мережах.`,
      input_hint: `Посилання може містити малі літери латинського алфавіту, цифри і підкреслення (_).`,

      tab_domain: 'Власний домен',
      connect_domain: 'Перевірити та підключити',
      domain_ip_text:
        'Вам необхідно вказати в налаштуваннях домену в особистому кабінеті Вашого доменного реєстратора DNS-запис типу "А" з IP-адресом нашого сервера: <span class="bold black-4-color">142.93.162.32</span>',
      domain_connect_text: `Зміни DNS записів вступлять в силу протягом 12 годин. Після внесення змін натисніть "Перевірити та підключити". Якщо з'явиться зелена галочка - Ваше меню буде доступно за вказаним доменом. SSL-сертифікат (підтримку https) буде підключено протягом декількох годин з моменту підключення домену.`,
    },
    liqpay: {
      title: `Онлайн оплата`,
      human: `Карта фіз. особи`,
      human_explain: `Вкажіть номер картки, на яку будуть надходити кошти за замовлення:`,
      company: `Рахунок юр. особи`,
      company_explain: `Вкажіть дані розрахункового рахунку, на який будуть надходити кошти за замовлення:`,
      company_account_number: `Номер рахунку`,
      company_mfo: `МФО`,
      company_edrpoy: `ЄДРПОУ`,
      company_name: `Назва компанії`,
      company_tax: 'ІПН',
      company_email: 'Електронна пошта',

      liqpay_account: `LiqPay`,
      liqpay_api_explain: `Вкажіть ключі API від Вашого аккаунту Liqpay, щоб оплата онлайн здійснювалась напряму на Ваш рахунок Liqpay:`,
      liqpay_api_pubkey: `Публічний ключ API`,
      liqpay_api_privkey: `Приватний ключ API`,
      liqpay_no_account: `Не маєте аккаунта Liqpay?`,

      liqpay_comment:
        'Комісія складає 2,75%, для реєстрації необхідно мати відкритий раухнок в ПриватБанку',
      wayforpay_comment:
        'Комісія складає 2,5%, для реєстрації підійде будь-який рахунок українського банку',

      wayforpay_account: 'Wayforpay',
      wayforpay_explain:
        'Вкажіть реквізити мерчанта Wayforpay, щоб онлайн оплата здійснювалась на Ваш рахунок:',
      wayforpay_account_ph: 'Логін мерчанта',
      wayforpay_secret_ph: 'Секретний ключ мерчанта',
      wayforpay_register: 'Зареєструвати мерчанта Wayforpay',
      register: `Зареєструватись`,
      data_is_protected: `Ваші банківські дані надійно захищені та не передаються третім особам`,
      confirm_tip: 'Після реєстрації, не забудьте активувати аккаунт та',
      apple_pay_tip: 'ввімкнути оплату через Apple Pay',

      stripe_explain:
        'Для прийому платежів через систему Stripe натисніть кнопку та перейдіть до налаштувань аккаунту.',
      stripe_active: 'Підключено аккаунт Stripe.',
      stripe_open_btn: 'Відкрити налаштування аккаунту Stripe',

      no_account: 'Не маєте аккаунту?',
      register_it: 'Зареєструйте його',
      comission: 'комісія',

      add_receiver: 'Додати рахунок',
      cancel_btn: 'Відміна',
      description_ph: 'Назва рахунку',
      choose_gateway: 'Оберіть платіжну систему:',

      liqpay_register_condition: 'тільки для клієнтів Приватбанку',
      wayforpay_register_condition: '',

      empty_list:
        'Додайте рахунок платіжної системи, щоб приймати оплату за замовлення онлайн.',

      confirm_remove:
        'Ви впевнені, що хочете видалити цей рахунок для онлайн оплати?',
    },
    currency: {
      title: 'Валюта',
      desc: 'Оберіть валюту Вашого закладу:',
    },
    timezone: {
      title: 'Часовий пояс',
      desc: 'Вкажіть часовий пояс Вашого закладу',
    },
    social: {
      title: 'Соц. мережі закладу',
      desc:
        'Ви можете розмістити посилання на соц. мережі закладу, щоб Ваші гості могли підписатись на них.',
      instagram: 'Посилання на Instagram',
      facebook: 'Посилання на Facebook',
      website: 'Веб-сайт закладу',
    },
  },
  subscription: {
    title_active: 'Активні підписки',
    title: 'Підписки',
    inactive: `Неактивна`,
    active_until: `Активна до`,
    paid_until: `Оплачена до`,
    trial_period_until: 'Пробний період до:',
    ended: `Закінчилась`,
    renew: `Відновити`,
    cancl: `Скасувати`,
    subscribe: `Оформити підписку`,
    cancel: `Ви впевнені, що хочете скасувати підписку на обрану систему?`,
    transactions: {
      title: `Історія платежів`,
      number: `# платежу`,
      date: `Дата`,
      time: `Час`,
      system: `Система`,
      method: `Метод оплати`,
      sum: `Сума`,
      commission: 'Комісія',
      balance: `Баланс`,
      status: `Статус`,
      success: `Успішно`,
      error: `Помилка`,
      reversed: 'Повернено',
      cash: `Готівка`,
      terminal: `Термінал`,
      online: `Онлайн`,
    },
    promo: {
      title: `Промокод`,
      input: `Вкажіть промокод для отримання додаткових послуг та бонусів, якщо він у Вас є.`,
      input_hint: `Введіть промокод`,
      connect: `Підключити`,
    },
    active_system_cancel:
      'Для цієї системи у Вас є активна підписка. Бажаєте її скасувати?',
  },
  workers: {
    title: `Персонал`,
    workers_editor: {
      title: `Офіціанти`,
      name: `Ім'я`,
      pin: `PIN-код`,
      hint: `Додайте офіціантів та вкажіть для них PIN коди.`,
      add: `+ Додати офіціанта`,
    },
    workers_queue: {
      version: `Веб-версія для планшетів та комп'ютерів`,
      title: `Панель замовлень`,
      id: `ID Панелі замовлень:`,
      link: `Посилання на вхід в панель замовлень: `,
      explain: `Ваші офіціанти переходять за цим посиланням та вводять встановлений для них PIN-код.            `,
    },
    notifications: {
      title: `Сповіщення`,
      about: `Отримуйте сповіщення про нове замовлення миттєво за допомогою Telegram боту.`,
      pt0: `Для підключення Telegram сповіщень:`,
      pt1: `1. Створіть чат з ботом`,
      pt2: `2. Напишіть команду`,
      pt3: `3. Введіть ID Вашого закладу -`,
      pt4: `4. Додайте всіх працівників, хто має приймати замовлення.`,
      users_count: 'Зараз в чаті з ботом {n} учасник(-а)',
    },
    mobile_app: {
      ios: 'Додаток для iOS',
      title: `Мобільний додаток`,
      explain: `Завантажте додаток для прийому та керування замовленнями.`,
      qr: `Відскануйте QR-код з мобільного пристрою (через камеру) або натисніть на іконку App Store`,
    },
    admin_bot: {
      title: `Бот для адміністратора`,
      explain: `Підключіть QRWaiter Business Bot щоб отримувати важливі сповіщення та звітність по діяльності закладу.`,
      authcode: `Код для авторизації:`,
      scan: 'Проскануйте цей QR-код, щоб підключити Telegram бота.',
    },
    guide: {
      title: 'Інструкція',
      description:
        'Ця інструкція допоможе Вашим працівникам розпочати роботу з панелю замовлень.',
      button: 'Завантажити інструкцію',
    },
  },
  inside: {
    test_button: 'Тестове замовлення',
    test_tooltip:
      'Відскануйте цей QR-код щоб переглянути меню та зробити тестове замовлення',
    services: {
      title: `Додаткові послуги`,
      input_hint: `Ви можете вказати додаткові послуги, які будуть доступні вашим гостям для замовлення. Наприклад: покликати офіціанта, прибрати стіл, принести додатковий набір наборів.`,
      service_name: `Назва послуги`,
      add: `Додати послугу`,
    },
    geolocation: {
      title: `Геолокація`,

      switcher_optional: `Необов'язкова`,
      switcher_required: `Обов'язкова`,

      off_desc:
        'Перевірка геолокації Ваших гостей вимкнена. Увімкніть перевірку, щоб уникнути фальшивих замовлень, які можуть бути зроблені поза межами закладу.',
      about: `Для того, щоб уникнути фальшивих замовлень, ми перевірятимемо на місцезнаходження в закладі кожного користувача. Якщо Ви вимикаєте цю функцію, то всі ризики та наслідки щодо фальшивих замовлень Ви берете на себе.`,
      disable_check: `Вимкнути перевірку геолокації`,
      check_disabled: `Ви вимкнули перевірку геолокації - створення замовлення буде можливим з будь якої локації одразу після сканування QR-коду.`,
      general_geo: `Увімкнути обов'язкову перевірку геолокації`,
      optional_geo: 'Увімкнути опціональну перевірку геолокації',
      radius_ph: 'Радіус дії стікерів (в метрах)',
      recommended_radius: 'Рекомендований радіус: 50 метрів',
      input_general: `Поставте мітку на карті, яка відповідає точному місцезнаходженню Вашого закладу та вкажіть радіус дії системи INSIDE.`,
    },
    halls: {
      title: `Зали і столи`,
      halln: `Зал`,
      hall_name: `Назва залу`,
      tables: `Столи`,
      hall: `Додати зали`,
    },
    stickers: {
      title: `Замовити стікери можна тут`,
      about: `Оберіть дизайн наклейок, які найкраще підходять для Вашого закладу.`,
      you_deside: `Цифровий друк дешевший, але наклейки такого типу придатні до 1 місяця.
            Наклейки широкоформатного друку якісні, стійкі, ламіновані і придатні рік і навіть більше.`,
      choose_format: `Оберіть формат друку`,
      digital: `Цифровий`,
      wideformat: `Широкоформатний`,
      order: `Замовити`,
      again: `ще раз`,
      amount: `шт.`,
      order_created: `Замовлення створено`,
      in_print: `Ваші стікери друкуються`,
      is_sent: `Стікери відправлені замовнику`,
      wait_wide: `Ваші стікери будуть виготовлені протягом 14 днів`,
      wait_digital: `Ваші стікери будуть виготовлені протягом 2 робочих днів.`,
      to_pay: `До сплати`,
      terms_of_delivery: `Умови доставки`,
      nova_poshta: `QR-коди будуть доставлені сервісом "Нова Пошта".`,
      input_data: `Вкажіть необхідні дані, щоб ми могли відправити Вам QR-коди.`,
      reciver_name: `ПІБ отримувача`,
      phone: `Номер телефону`,
      np_warehouse: `Відділення Нової Пошти`,
      choose_warehouse: `Оберіть відділення`,
      online_prepay: `Онлайн передплата`,
      what_you_pay_for: `Ви оплачуєте послугу друку QR-кодів.`,
      pay_order: `Оплатити замовлення`,
      return: `Повернутись до вибору шаблону`,
      is_protected: `Ваші банківські дані надійно захищені та не передаються третім особам.`,
      download_lite: 'Завантажити стікер для INSIDE lite',
      no_sections:
        'Ви не можете замовити стікери, поки не вкажете кількість залів та столів в налаштуваннях закладу.',
      is_protected: `Ваші банківські дані надійно захищені та не передаються третім особам.`,

      contacts: 'Вкажіть Ваші контакти, щоб ми могли Вам відправити стікери',
      name_ph: 'ПІБ отримувача',
      phone_ph: 'Номер телефону',
      address_ph: 'Адреса отримувача',
      comment_ph: 'Коментар',

      delivery_way: 'Оберіть спосіб доставки:',
      by_novaposhta: 'Нова Пошта',
      by_courier: `Кур'єром`,

      price: 'Вартість Ваших стікерів становить: ',
      order_button: 'Оплатити стікери',

      order_accepted:
        'Ваше замовлення від {date} на друк наклейок {template} було прийнято.',
      choose_language: 'Оберіть бажану мову стікерів:',
    },
    self_serve: {
      title: `Самообслуговування`,
      if_turned_on: `В цьому режимі гість отримає сповіщення коли його замовлення буде готово, і що його потрібно буде забрати.`,
      turn_on: `Режим "Самообслуговування"`,
    },
  },
  preorder: {
    min_order_time: {
      title: `Мінімальний час на приготування`,
      current:
        'Гість може отримати замовлення не раніше як через {time} від моменту його створення',
      input: `Вкажіть мінімальний час, за який клієнт може зробити передзамовлення.`,
    },
    time_limit: {
      title: `Графік роботи`,
      current: 'Останнє замовлення приймається за {time} до закриття.',
      zero: 'Останнє замовлення приймається до закриття закладу.',
      input: `Вкажіть за скільки часу до закриття закладу приймати останнє замовлення.`,
    },
    packaging: {
      // title: `Вартість упаковки`,
      // free_packaging: `Безкоштовна упаковка`,
      // free_packaging_about: `Упаковка повністю безкоштовна і не додається клієнту в чек.`,
      // paid_packaging_fixed: `Платна упаковка (стала вартість)`,
      // paid_packaging_price: `Вартість упаковки:`,
      // no_mater: `Вказана сума завжди додається клієнту в чек, в незалежності від вибраних страв і їх кількості.`,
      // paid_packaging_percent: `Платна упаковка (змінна вартість)`,
      // paid_packaging_about: `Система автоматично обчислює загальну вартість упаковки, підбираючи розмір або об'єм упаковки під кожну страву.`,
      // volume: `Об'єм упаковки`,
      // g: `Грам`,
      // l: `Літр`,
      // price: `Вартість`,
      // price_placeholder: `30 грн`,
      // add_packaging: `Додати упаковку`,
      // ensure: `Переконайтесь, що для кожної страви знайдеться упаковка, що може її вмістити.`
      title: 'Вартість упаковки',
      type_free: 'Безкоштовна упаковка',
      type_non_free: 'Платна упаковка',
      type_constant: 'Фіксована вартість',
      type_weighted: 'Змінна вартість',

      no_variants:
        'У Вас є порожня група модифікаторів типу "варіанти", додайте хоча б 1 варіант щоб налаштувати ціну упаковку або видаліть групу варіантів щоб виставити ціну упаковку на всю страву.',

      dish_desc:
        "Вкажіть об'єм упаковки та її вартість. Якщо упаковка для даної страви може змінюватись в залежності від її ваги, то вкажіть декілька упаковок, наш алгоритм автоматично підбере потрібну.",

      constant_hint: 'Вказана Вами сума буде автоматично додаватись до чеку.',

      unit_ph: 'Тип',
      unit_l: 'Напій',
      unit_g: 'Страва',
      unit_cm: 'Піца',

      weight_l: `Об'єм`,
      weight_g: 'Вага',
      weight_cm: 'Розмір',
      weight_null: '-',

      price_ph: 'Вартість',

      add_package: 'Додати упаковку',

      type_hint: 'При додаванні упаковки оберіть її тип.',

      smart_comment:
        'Вартість упаковки буде визначатись автоматично. Перейдіть у меню, щоб налаштувати вартість упаковки окремо для кожної страви.',
      smart_btn: 'Перейти до налаштувань меню',
    },
    payment: {
      title: `Оплата`,
      cash: `Готівкою`,
      cash_courier: `Клієнт буде розраховуватись готівкою при отриманні замовлення.`,
      cash_about: `Клієнт буде розраховуватись готівкою при отриманні замовлення.`,
      card: `Терміналом`,
      card_about: `Розрахунок карткою через термінал.`,
      online: `Онлайн`,
      online_about: `Онлайн оплата замовлення за Вашими реквізитами (передплата)`,
      bonus: 'Бонусами',
    },
    allow_reservation: {
      title: 'Спосіб отримання замовлення',
      eat_in: 'В закладі (eat in)',
      takeaway: 'З собою (takeaway)',
      comment:
        'Ви можете налаштувати логіку роботи системи TAKEAWAY індивідуально під свій заклад. Вкажіть можливі способи здійснити замовлення.',
      warning:
        'Система TAKEAWAY не будет працювати, поки Ви не виберете щонайменше спосіб отримання замовлення.',
      // option: 'Дозволити бронювати стіл для передзамовлення'
    },
  },
  delivery: {
    min_check: {
      title: `Мінімальна сума чеку`,
      off_desc: 'Ви можете встановити мінімальну суму замовлення',
      on_desc:
        'Гості зможуть відправити замовлення тільки якщо сума чеку перевищує мінімальну суму замовлення.',
      min_about: `Вкажіть мінімальну суму замовлення, яку клієнт має набрати, щоб відправити замовлення.`,
    },
    price: {
      title: 'Вартість доставки',

      type_free: 'Безкоштовна',
      type_conditional: 'Змінна',
      type_constant: 'Платна',

      amount_ph: 'Введіть суму',

      free_after: 'Доставка безкоштовна після вказаної суми.',
      rules_before: 'Розрахунок вартості доставки до вказаної суми',

      fixed_price: 'Фіксована вартість',
      courier_price: `Тариф кур'єра`,
      courier_desc: `Якщо вартість доставки рахується за тарифом кур'єра, то клієнт розраховується готівкою при отриманні.`,

      add_cost_to_check: 'Додавати вартість доставки в чек',
    },
    geo: {
      title: `Зони доставки`,
      input_zones: `Вкажіть зони (координати та радіуси), в яких працює доставка з Вашого закладу.`,
      no_zones: `Зони не вказані`,
      zones_hint: `Клацніть в потрібному місці на карті щоб встановити маркер для`,
      zone_t: `зони`,
      zone: `Зона`,
      radius: `Радіус (км)`,
      add_zone: `Додати зону`,

      explain:
        'QRWaiter автоматично перевіряє адресу клієнта, і дає можливість зробити замовлення тільки якщо вона входить в зону доставки.',

      click_to_add: `Натисніть на відповідне місце на карті, щоб додати зону доставки (центр зони не обов'язково має співпадати з адресою закладу)`,
      desc:
        'Позначте зони доставки на карті. Для більш точного налаштування, Ви можете додати одразу декілька зон.',
    },
  },
  reserve: {
    price: {
      title: `Платне бронювання`,
      free: 'Бронювання безкоштовне',
      setup:
        'Зверніть увагу що платне бронювання не буде активовано, поки не буде обрано рахунок для зарахування коштів',
      input: `Вашим гостям необхідно буде оплатити депозит (онлайн) для того, щоб забронювати стіл.`,
    },
    max_days: {
      title: `Дата бронювання`,
      input: `Ви можете вказати на скільки днів наперед можна зробити бронювання.`,
    },
    max_guests: {
      title: `Кількість осіб`,
      input: `Ви можете вказати максимальну кількість осіб, на яку можна зробити бронювання.`,
    },
    payment: {
      title: `Оплата`,
      to_card: `Переказ на номер картки`,
      input_card: `Вкажіть номер картки, на яку будуть надходити кошти за замовлення:`,
      to_bank_account: `Переказ на розрахунковий рахунок`,
      input_bank: `Вкажіть дані розрахункового рахунку, на який будуть надходити кошти за замовлення:`,
      account_number: `Номер рахунку (14 цифр)`,
      mfo: `МФО рахунку`,
      edrpou: `Код ЄДРПОУ`,
      company_name: `Назва компанії`,
      liqpay: `Оплата на аккаунт мерчанта Liqpay`,
      api_key: `Вкажіть ключі API від Вашого аккаунту Liqpay, щоб оплата онлайн здійснювалась напряму на Ваш рахунок Liqpay.`,
      pubkey: `Публічний ключ API`,
      privkey: `Приватний ключ API`,
      no_liqpay: `Не маєте аккаунта Liqpay?`,
      liqpay_register: `Зареєструватись`,
      data_is_protected: `Ваші банківські дані надійно захищені та не передаються третім особам`,
    },
    allow_same_day: {
      title: 'Безпечне бронювання',
      comment:
        'Для того щоб уникнути перебронювань та непорозумінь з гостями, ми дозволяємо Вашим гостям бронювати столи тільки на наступний день. Але Ви можете вимкнути це обмеження, знявши галочку.',
      toggle: 'Безпечне бронювання',
    },
  },
  busy_modal: {
    title: 'Зачекайте, оновлюємо інформацію...',
  },
  menu_languages: {
    btn_add: 'Додати переклад',

    settings_title: 'Переклади меню',
    main_language: 'Основна мова',
    alt_language: 'Альтернативна мова',
    preview_title: 'Попередній перегляд оригіналу',
    preview_desc:
      'Ввімкніть цю опцію щоб підсвітити непереведені назви та щоб показати підсказку з текстом оригіналу при вводі перекладу',
    remove_language_confirm:
      'Ви впевнені, що хочете видалити переклади для цієї мови?',
  },
  updated_language_modal: {
    title: 'Додавання перекладу',
    subtitle: 'Виберіть мову, на які Ви хочете перевести Ваше меню',
    subtitle_original: 'Будь ласка, виберіть основну мову для цього меню',
    search: 'Пошук',
    btn_add: 'Додати мову',
    languages_plural: 'Мову не вибрано | {n} мову вибрано | {n} мови вибрано',
    set_original: 'Встановити мову оригіналу',
  },
  language_modal: {
    head: 'Додавання альтернативної мови',
    choose_lang: 'Оберіть мову для меню',
    menu_lang_comment:
      'Переклади для альтернативних мов Ви можете прописати поверх оригінальних назв в редакторі категорій та налаштуваннях страви. Непереведні назви будуть виділятись червоним кольором.',
    confirm_btn: 'Додати мову',
    cancel_btn: 'Скасувати',
  },
  integrations: {
    order_title: 'Замовити інтеграцію',
    order_desc:
      'Якщо Ви не знайшли Вашу POS-систему в списку інтеграцій, то Ви можете залишити заявку і ми налаштуємо інтеграцію з Вашою системою додатково.',
    order_button: 'Замовити інтеграцію',
    order_ph: 'Назва POS-системи',
    order_sent: 'Вашу заявку відправлено.',
    supported: {
      title: `Доступні інтеграції`,
      you_can_connect: `Ви можете підключити сторонню систему обліку до системи QRWaiter.`,
      currently_supported: `Наразі ми підтримуємо наступні інтеграції (натисність, щоб підключити):`,
    },
    poster_status: {
      title: 'Інтеграція з Poster',
      active: 'Активна',
      description:
        'Ця інтеграція дозволяє синхронізувати Ваш аккаунт QRWaiter з аккаунтом Poster. Автоматично буде імпортовано меню, працівників, зали і столи.',
      connect: 'Увімкнути інтеграцію',
      // active: 'Інтеграція з Poster увімкнена.',

      disable: 'Вимкнути інтеграцію',
      disable_modal:
        'Для вимкнення інтеграції перейдіть в каталог Poster та натисніть "Відключити" на сторінці додатку QRWaiter.',
      account_id: 'Аккаунт Poster:',
      was_disconncted:
        'Інтеграція з QRWaiter була вимкнена через адмін панель Poster. Для коректної роботи необхідно підключити її ще раз.',
    },
    poster_menu_input: {
      search_ph: 'Пошук товара або тех. карти в системі Poster...',
      modificator_input_none: '- без модифікатора -',
      modificator_input_prefix: 'Модифікатор',
    },
    pos_product_link: {
      title: 'Інтеграція з POS',
      desc:
        'Ви можете прив’язати тех. карту (або ж її модифікацію) з POS системи до даної страви ',
      has_variants: `Інтеграція з POS-системою налаштована черз групу модифікаторів (варіанти). До кожного модифікатору прив'язана індивідуальна тех. карта з POS-системи`,
    },
    poster_sync: {
      title: 'Синхронізація',
      description:
        'Оберіть, які параметри в автоматичному режимі слід синхронізувати з системою Poster',
      sync_menu: 'Меню',
      sync_tables: 'Синхронізувати зали і столи',
      sync_waiters: 'Працівники',
      sync_storage: 'Залишки на складах',
      sync_transactions: 'Чеки INSIDE',

      desc_transactions:
        'Ця опція буде синхронізувати вміст замовлень системи INSIDE, якщо Ви змінете їх в терміналі Poster',
      desc_storage:
        'Ця опція буде синхронізувати наявність кожної страви в залежності від залишків на складах в Poster.',
      desc_menu:
        'Ця опція буде постійно синхронізувати фотографії та ціни на страви і модифікатори в меню',
      desc_waiters:
        'При створенні працівника в Poster він буде автоматично створюватись і в системі QRWaiter',
    },
    iiko_menu_input: {
      search_ph: 'Пошук тех. карти в системі iiko...',
    },
    poster_settings: {
      title: `Заклад`,
      choose_poster_spot: `На Вашому аккаунті Poster є декілька закладів. Оберіть заклад Poster, на термінали якого повинні надходити замовлення від QRWaiter.`,
      choose_spot: `оберіть заклад`,
      term_no: `Термінал`,
      update_prices_request:
        'Оскільки Ви змінили заклад Poster, чи бажаєте Ви оновити всі ціни в меню QRWaiter відповідно до прейскуранту нового закладу в Poster?',
    },
    poster_health: {
      title: 'Зверніть увагу',
      not_healthy: 'Інтеграція працює некоректно',
      waiters_title: 'Відсутні наступні співробітники в системі QRWaiter:',
      waiters_desc:
        'Система QRWaiter не зможе коректно створити чек в Poster, якщо відсутні в QRWaiter співробітники приймуть замовлення на терміналі Poster.',

      halls_title: 'Відсутні наступні зали в системі QRWaiter:',
      halls_desc:
        'Система QRWaiter не зможе створити замовлення на коректному столі, якщо ці зали відсутні.',
    },
    poster_integration: {
      title: `Активна інтеграція`,
      working: `Працює інтеграція з системою Poster.`,
      connected: `Підключена`,
      user: `користувачем`,
      import_title: 'Імпорт даних',
      import_hint: 'Оберіть дані, які Ви бажаєте імпортувати з Poster.',
      import_menu: `Імпортувати меню`,
      import_workers: `Імпортувати працівників`,
      import_halls: `Імпортувати зали і столи`,
      destroy_action: 'Вимкнути інтеграцію',
      warning_destroy: 'Ви впевнені, що хочете вимкнути інтеграцію?',
      warning_workers: `При імпорті працівників з Poster, інформація про працівників у системі QRWaiter буде перезаписана (втрачена). Ви впевнені?`,
      warning_halls: `При імпорті налаштувань залів і столів з Poster, інформація про них у системі QRWaiter буде перезаписана (втрачена). Ви впевнені?`,
      warning_menu:
        'При імпорті буде створено дві повні копії меню з назвами "Кухня" та "Бар".',
    },
    poster_instant_ui: {
      title: 'Миттєвий інтерфейс замовлень',
      desc:
        'Увімкніть цю опцію, щоб інтерфейс для прийому замовлення показувався на терміналі Poster одразу після отримання сповіщення про нове замовлення.',
    },
    poster_connect: {
      title: `Інтеграція`,
      wait: `Зачекайте, йде налаштування інтеграції...`,
      success: `Інтеграція налаштована, тепер Вам доступні функції інтеграції такі як імпорт меню.`,
      return: `Повернутись до інтеграцій`,
      failed: `Не вдалось завершити процес інтеграції. Будь ласка, спробуйте пізніше або зверніться до тех. підтримки.`,
    },
    iiko_connect: {
      title: 'Інтеграція з iiko',
      connect_btn: 'Підключити інтеграцію',
      active: 'Активна інтеграція з iiko від',
      disconnect: 'Відключити інтеграцію',
      download: 'Завантажити плагін',
      confirm_disconnect:
        'Ви впевнені, що хочете відключити інтеграцію з iiko?',
    },
    iiko_connect_modal: {
      download:
        '1. Завантажте архів з нашим плагіном інтеграції для iikoFront:',
      extract:
        '2. Розпакуйте скачаний архів в підпапку <span class="c-white">"Plugins/QRWaiterIikoPlugin"</span>, яку можна знайти в директорії де встановлений iikoFront (зазвичай це <span class="c-white">C:\\Program Files\\iiko\\iikoRMS\\Front.Net</span>). В результаті файл QRWaiterIikoPlugin.dll має бути розміщений за шляхом <span class="c-white">C:\\Program Files\\iiko\\iikoRMS\\Front.Net\\Plugins \\QRWaiterIikoPlugin\\QRWaiterIikoPlugin.dll</span>',
      license:
        '3. Встановіть 1 слот ліцензії apiPayment <span class="c-white">(ID 21016318)</span>, вона необхдіна для роботи плагіна QRWaiter.',
      restart: '4. Перезапустіть iikoFront.',
      connect:
        '5. Через додаткові меню плагінів, відкрийте меню QRWaiter та введіть код підключення інтеграції',

      autoclose: 'Це вікно буде автоматично закрито після введення коду.',
    },
    iiko_disconnect: {
      title: 'Будь ласка, зачекайте, відключення інтеграції...',
      subtitle: 'Переконайтесь, що iikoFront відкритий.',
    },
    iiko_import: {
      menu_btn: 'Імпортувати меню',
      workers_btn: 'Імпортувати працівників',
      tables_btn: 'Імпортувати зали і столи',

      menu_sent:
        'Запит на імпорт меню відправлено. Будь ласка, переконайтесь що інтерфейс iikoFront відкритий. Меню буде імпортовано через декілька секунд.',

      workers_confirm:
        'Ви впевнені, що хочете імпортувати дані працівників з iiko? Поточні налаштування працівників буде перезаписано',
      tables_confirm:
        'Ви впевнені, що хочете імпортувати дані залів і столів з iiko? Поточні налаштування залів і столів буде перезаписано.',

      workers_sent:
        'Запит на імпорт працівників відправлено. Будь ласка, переконайтесь що інтерфейс iikoFront відкритий.',
      tables_sent:
        'Запит на імпорт залів і столів відправлено. Будь ласка, переконайтесь що інтерфейс iikoFront відкритий.',
    },
  },
  reviews: {
    averange: `Середня оцінка`,
    reviews: `Відгуки`,
    no_reviews: 'Тут будуть відображатись відгуки від Ваших гостей.',
    no_review_title: 'У вас поки немає відгуків.',
    anonymous: 'Анонім',
  },
  settings: {
    title: `Налаштування`,
    mail: {
      title: `Зміна електронної адреси`,
      current: `Ваша поточна адреса`,
      new: `Введіть нову адресу`,
      wait: `Зачекайте...`,
      confirm: `Для підтвердження введіть пароль`,
      change: `Змінити адресу`,
      sent: `На вказану нову адресу був надісланий лист для підтвердження.`,
      errorp: `Не вдалось змінити адресу. Перевірте правильність паролю.`,
      errorl: `Не вдалось змінити електронну пошту. Перевірте правильність посилання.`,
      changed: `Вашу адресу електронної пошти успішно змінено. Переадресація...`,
    },
    delete: {
      title: `Видалення аккаунту`,
      pwd: `Пароль`,
      password: `Для видалення аккаунту введіть свій пароль`,
      warn: `УВАГА!`,
      warnt: `Ця дія є незворотньою і видаляє всю інформацію, пов'язану з Вашим аккаунтом QRWaiter: заклад, меню, замовлення, налаштування та ін.`,
      unable: ` Не вдалось видалити аккаунт. Будь ласка, перевірте правильність паролю.`,
      about: `Ви можете видалити свій аккаунт QRWaiter, проте ця дія є незворотньою.`,
      delete: `Видалити аккаунт`,
      cancel: `Відміна`,
      deleted: `Аккаунт видалено, переадресація...`,
    },
    language: {
      title: `Мова`,
      choose: `Виберіть бажану мову для сповіщень:`,
    },
    password: {
      title: `Зміна паролю`,
      current: `Поточний пароль`,
      new: `Новий пароль`,
      repeat: `Повторіть новий пароль`,
      change: `Змінити пароль`,
      success: `Ваш пароль успішно змінено!`,
      errord: `Ваші нові паролі не співпадають.`,
      erroro: `Змінити пароль не вдалось. Перевірте правильність поточного паролю.`,
    },
    two_factor: {
      title: 'Двухфакторна авторизація',
      change_phone: 'Змінити номер телефону',
      description:
        'Двухфакторна авторизація - стандарт безпеки другого рівня. Для кожної авторизації в Адмін панель Вам буде приходити SMS з підтвердженням.',
      description_active:
        'На цей номер буде приходити код для підтвердження кожен раз, як здійснюється вхід в Ваш аккаунт QRWaiter',
      checkbox: 'Увімкнути підтвердження через SMS',

      set_phone_desc: 'Вкажіть свій номер телефону',
      set_code_desc: 'Ввведіть код з SMS',

      confirm_phone: 'Підтвердити номер телефону',

      is_active: 'Двухфакторна авторизація активована.',

      confirm_code_ph: 'Код підтвердження (6 цифр)',

      send_sms: 'Відправити SMS',
    },
  },
  marketing: {
    title: 'Маркетинг',
    tab_campaigns: 'Рекламні кампанії',
    tab_loyalty: 'Програма лояльності',
    tab_promocodes: 'Промокоди',
    tab_discounts: 'Промоакції',

    desc_campaigns:
      'Створюйте посилання для рекламних кампаній та відслідковуйте їх ефективність',
    desc_loyalty: 'Надавайте своїм гостям бонус від чеку',
    desc_promocodes: 'Створюйте промокоди для проведення розіграшів або акцій',
    desc_discounts: 'Створюйте промоакції на страви або категорії в меню',
  },
  campaign_card_old: {
    iqos_title: 'Посилання для реклами',
    title_ph: 'Назва кампанії',
    link: 'Посилання:',
    period: 'Період дії:',
    total_visits: 'Кількість переглядів меню:',
    unique_visits: 'Кількість унікальних користувачів:',
    delete: 'Видалити кампанію',
    confirm_delete: 'Ви впевнені, що хочете видалити цю кампанію?',
    add_campaign: '+ Створити посилання для рекламної кампанії',
    new_campaign_ph: 'Назва для нової кампанії',
    iqos_desc:
      'Використайте це посилання для рекламної кампанії та відслідковуйте її ефективність.',
    force_mode_none: '- не пропускати вибір системи -',
  },
  address_details: {
    types: {
      entrance: `Під'їзд`,
      floor: 'Поверх',
      flat: 'Квартира',
    },
    title: 'Доставка до дверей',
    description: `Якщо у Вас власні кур'єри, які доставляють "до дверей", Ви можете запитувати у Ваших гостей додаткові деталі адресу. Ці деталі є необов'язковими.`,
    required:
      'За замовчуванням QRWaiter просить надати тільки адресу та номер будинку.',
  },

  update_bar: {
    text:
      'Доступне оновлення панелі адміністратора. Сторінка перезавантажиться автоматично через 30 секунд.',
    button: 'Перезавантажити зараз',
    description: `Вкажіть додаткові деталі адреси, які клієнт може вказати для замовлення на доставку (ці поля будуть необов'язковими).`,
  },
  tables: {
    orders_history: 'Історія замовлень',
    payments_history: 'Історія платежів',
    search: 'Пошук...',
    export: 'Експорт',
  },
  halls_tables: {
    title: 'Зали і столи',
    reserve_title: 'Столи для бронювання',
    no_halls:
      'Зали і столи не налаштовані. Натисніть на кнопку редагування, щоб додати їх.',
    hall_ph: 'Назва залу',
    add_hall: 'Додати зал',
    places_count: 'Місця',
    not_filled: 'Не вказано',
    table: 'Стіл',
    room: 'Номер',
    name_ph: 'Назва столу',
    places_ph: 'Кількість місць',
    delete_btn: 'Видалити',
    remove_hall: 'Видалити зал',
    places_count_plural: 'місце | місць',
    confirm_remove_hall:
      'Ви впевнені, що хочете видалити цей зал? Стікери, що були надруковані на столи цього залу, не будуть працювати.',
    add_btn: 'Додати стіл',
    reserve_missing: 'Жоден стіл не вибрано для бронювання',
    reserve_red_desc:
      'Столи, що виділені червоним кольором, не мають налаштованої кількості місць. Для системи RESERVE можна обрати лише столи з вказаною кількістью місць',
    description:
      'Вкажіть зали, кількість столів в них та кількість вільних місць за кожним столом. Це потрібно для правильного розрахунку кількості стікерів для системи INSIDE та безпечних бронювань для системи RESERVE.',
    reserve_description:
      'Для того щоб Ваші гості могли забронювати стіл через сервіс QRWaiter, Вам потрібно виділити не менш як 1 стіл, який гарантовано буде вільний в разі його бронювання через сервіс RESERVE.',
    reserve_description2:
      'Допустима кількість осіб підраховується автоматично. Щоб змінити зали або кількість столів - перейдіть в загальні налаштування закладу.',
    pos_sync: 'Синхронізувати з POS системою',
  },
  changelog: {
    title: 'Сповіщення від QRWaiter',
  },
  reserve_policy: {
    title: 'Політика RESERVE',
    text:
      'Для того щоб система RESERVE була доступна в маркеплейсі QRWaiter, Вам потрібно прочитати та погодитись з умовами користування та політикою маркетплейсу QRWaiter.',
    checkbox: 'Я прочитав та погоджуюсь з умовами політики QRWaiter | RESERVE',
  },
  corporate_employees: {
    all_permissions: {
      general: 'Налаштування закладу',
      stats: 'Статистика',
      marketing: 'Маркетинг',
      systems: 'Налаштування систем',
      menu: 'Редактор меню',
      integrations: 'Інтеграції',
      payment: 'Онлайн-оплата',
      '*': 'Повний доступ',
    },
  },
  auditlog: {
    title: 'Історія змін',
    columns: {
      user: 'Користувач',
      date: 'Дата',
      time: 'Час',
      action: 'Дія',
    },
    select_cafe: 'Оберіть заклад',
    types: {
      cafe_settings:
        'Змінив загальні налаштування закладу ({name}, {description}, {address})',
      clients_export: 'Експортував клієнтську базу',
      pay_methods: 'Змінив методи оплати ({mode})',
      marketing_new_campaign: 'Створив нове посилання для реклами ({title})',
      marketing_remove_campaign: 'Видалив посилання для реклами ({title})',
      loyalty_change: 'Змінив відсоток програми лояльності ({percent}%)',
      cafe_schedule: 'Змінив графік роботи закладу',
      online_menu_link: 'Змінив посилання на онлайн меню ({link})',
      social_links: 'Змінив соц. мережі закладу',
      waiters: 'Змінив налаштування офіціантів',
      poster_import_menu: 'Імпортував меню з системи Poster',
      poster_import_tables: 'Імпортував зали і столи з системи Poster',
      poster_import_workers: 'Імпортував працівників з системи Poster',
      mode_disable: 'Відключив систему ({mode})',
      mode_enable: 'Підключив систему ({mode})',
      inside_services: 'Змінив послуги в INSIDE',
      inside_geolocation: 'Змінив налаштування геолокації в INSIDE',
      packaging: 'Змінив налаштування упаковки ({mode})',
      delivery_price: 'Змінив налаштування ціни доставки',
      reserve_allow_today:
        'Змінив налаштування безпечного бронювання в RESERVE',
      menu_create: 'Створив меню "{title}"',
      menu_tag: 'Змінив тег меню "{tag}"',
      menu_delete: 'Видалив меню "{title}"',
      menu_duplicate: 'Зробив копію меню "{title}"',
      menu_toggle: 'Перемекнув режим "{mode}" для меню {title} ({value})',
      create_cafe: 'Створив новий заклад ({name}, {address})',
      regional_settings: 'Оновив регіональні налаштування',
      add_employee: 'Створив нового працівника {name}, {email}',
      remove_employee: 'Видалив працівнника {name}, {email}',
      update_employee: 'Змінив налаштування для працівника {email}',
      remove_menu_product:
        'Видалив страву {name} з категорії {category} ({menu_title})',
      remove_menu_category:
        'Видалив категорію {category_name} з меню {menu_title}',
      add_online_merchant: 'Створив онлайн мерчанта ({gateway})',
      update_online_merchant: 'Змінив налаштування онлайн мерчанта',
      change_client_discounts:
        'Змінив налаштування бонусів та знижки для клієнта {client_name}',
      create_promocode: 'Створив промокод',
      delete_promocode: 'Видалив промокод ({count} шт.)',
      create_discount: 'Створив знижку',
      delete_discount: 'Видалив знижку ({size}%)',
      change_menu_pay_receiver:
        'Змінив рахунок для онлайн оплати на меню {menu_title}',
      change_menu_product_price: 'Змінив ціну страви {dish_name} ({price})',
      change_menu_product_photo: 'Змінив фото страви ({dish_name})',
      create_menu_product_modificators:
        'Створив групу модифікаторів в страві {dish_name}',
      delete_menu_product_modificators:
        'Видалив групу модифікаторів з страви {dish_name}',
      cancel_subscription: 'Скасував підписку на систему {mode}',
      change_mode_motd: 'Змінив вітальний текст для системи {mode} ({value})',
      change_reserve_price: 'Змінив ціну на RESERVE ({value})',
      change_poster_sync: 'Змінив налаштування синхронізації з Poster',
      change_tables: 'Змінив налаштування залів і столів ({halls_count} залів)',
      change_food_flavors: 'Змінив категорії закладу в маркетплейсі',
      change_menu_product_integration:
        'Змінив налаштування інтеграції для страви {dish_name} ({platform})',
      transfer_menu_product: 'Перемістив страву {dish_name}',
      delete_menu_product_modificator:
        'Видалив модифікатор {modificator_name} з страви {dish_name}',
      change_menu_product_name: 'Змінив назву страви {dish_name}',
    },
  },
  add_corporate_cafe: {
    modal_title: 'Створення нового закладу',
    button: 'Додати',

    add_chain: 'Створити мережу',
    chain_ph: 'Назва мережі',

    tab_new: 'Новий',
    tab_duplicate: 'Дублікат',

    tab_cafe: 'Заклад',
    tab_chain: 'Мережа',

    new_desc:
      'Вкажіть інформацію про заклад, який Ви бажаєте зареєструвати в QRWaiter.',
    duplicate_desc:
      'Оберіть заклад, з якого Ви бажаєте продублювати меню, підключені системи та їх налаштування.',

    name_ph: 'Назва закладу',
    address_ph: 'Адреса',

    select_cafe: '- Оберіть заклад -',

    cancel: 'Скасувати',
    register: 'Створити',

    no_chain: '- Заведение вне сети -',
  },
  corporate_users: {
    desc:
      'Ви можете надавати доступ до керування Вашим закладом з налаштуванням рівнів доступу.',
    add_user: '+ Додати аккаунт',
  },
  add_employee: {
    add_user: 'Додати користувача',
    title: 'Додавання аккаунту',
    comment:
      'Ви можете надавати доступ до Адмін панелі вашого закладу своїм працівникам, налаштувавши відповідний рівень доступу.',
    name_ph: `Вкажіть ім'я користувача`,
    role_ph: 'Вкажіть посаду користувача',
    phone_ph: 'Вкажіть номер телефону',
    email_ph: 'Електронна адреса користувача',
    choose_permissions: 'Оберіть до яких функцій користувач матиме доступ',
    choose_cafe: 'Оберіть заклад',
    cancel: 'Скасувати',
    confirm: 'Відправити запрошення',
  },
  employee_card: {
    user_num: 'Користувач',
    not_activated: 'Запрошення відправлено.',
    cancel_invite: 'Скасувати запрошення',
    activated: 'Аккаунт активований',
    delete_warning:
      'Якщо Ви видалите користувача, його доступ до закладу буде втрачено.',
    delete_button: 'Видалити',

    not_activated_desc:
      'Запрошення було відправлено на електронну пошту користувача. Доступ буде надано, як тільки він підтвердить реєстрацію.',
    activated_desc:
      'Аккаунт користувача активний, він має доступ до всіх перерахований функцій.',
  },
  moeco_partner: {
    title: 'Екологічна доставка',
    connect_desc:
      'Ви можете підключити інтеграцію по доставці з нашим партнером "moeco". Водії будуть заздалегіть попереджені про замовлення на доставку, Вам залишиться тільки вчасно їх приготувати.',
    connect_btn: 'Підключити "Еко" доставку',
    pending_desc: `Вашу заявку на підключення доставки відправлено, партнер доставки зв'яжеться з Вами в найближчий час.`,
    active: 'Активна еко-доставка з moeco по наступному тарифу:',
    cost: 'Вартість доставки:',
    refuse_cost: 'Вартість скасування доставки:',
    payer_client: 'За доставку платить клієнт',
    payer_cafe: 'За доставку платить заклад',
    payer_conditional: 'Оплата доставки залежить від суми чека',
    conditional_desc:
      'Доставку замовлення буде оплачувати заклад, якщо сума чеку перевищує всі вище вказані налаштування.',
    conditional_example:
      'Наприклад, якщо вказати дві умови (250 грн сума чеку, 65 грн доставка) та (500 грн сума чека, 30 грн доставка), то якщо клієнт зробить замовлення на суму до 250 грн - вартість доставки складатиме 65 грн, на суму від 250 до 500 - гість заплатить за доставку 30 грн, а на 500 грн і більше - доставка буде безкоштовна для гостя',

    smart_option: 'Автоматичне замовлення машини',
    manual_option: 'Ручне замовлення машини',
    smart_desc:
      'Система QRWaiter автоматично буде замовляти машину на необхідний час, офіціанту необхідно буде лише прийняти замовлення.',
    manual_desc:
      'Машину замовляти необхідно буде власноруч офіціанту, вказуючи час, на який її потрібно подати.',
  },
  moeco_block: {
    title: 'Еко доставка від "Моє Таксі"',
    comment:
      'Ви можете підключити інтеграцію з нашим партнером по доставці "Моє Таксі". Водії будуть автоматично заздалегідь попереджені про нові замовлення на доставку. Вам залишиться тільки вчасно їх приготувати.',
    comment_2: 'Більше ніяких очікувань на лінії відповіді диспетчера',

    connect_btn: 'Підключити інтеграцію з "Моє Таксі" 🚀',

    request_sent:
      'Ваша заявка на підключення відправлена. Як тільки "Моє Таксі" підтвердить інтеграцію та тарифи - Ви отримаєте сповіщення.',

    ready_title: 'Оберіть режим замовлення машин для доставки',
    smart_option: 'Автоматичний',
    manual_option: 'Ручний',

    planned_count:
      'Планова кількість замовлень, яку Вам потрібно виконати за допомогою інтеграції:',

    smart_desc:
      'Система QRWaiter автоматично буде замовляти машину на необхідний час, офіціанту необхідно буде лише прийняти замовлення.',
    manual_desc:
      'Для виклику машини, потрібно натиснути на кнопку "Замовити машину" в додатку для персоналу. Кнопка виклику з\'являється під кожним замовленням після його прийняття',
    price: 'Ваш тариф:',
    disconnect: 'Відключити інтеграцію з "Моє Таксі" 😕',
  },
  client_base: {
    title: 'Клієнтська база',
    total_orders: 'Всього замовлень',
    total_visits: 'Візитів',
  },
  serving_fee: {
    title: 'Комісія за обслуговування',
    enable: 'Ввімкнути комісію за обслуговування',
    mode_enable:
      'Ввімкнути стягненні комісії за обслуговування для цієї системи',
    percent_ph: 'Розмір комісії (%)',
    comment:
      'Вказаний відсоток буде автоматично додаватись до вартості кожного чеку.',
  },
  taxes_fee: {
    title: 'Податок',
    enable: 'Включати податок в чек замовлення',
    percent_ph: 'Розмір податку (%)',
    comment:
      'Вказаний відсоток буде автоматично додаватись до вартості кожного чеку.',
  },
  taxi_price_panel: {
    limit_ph: 'Сума чеку',
    price_ph: 'Вартість доставки',
    add_button: '+ Додати умову',
  },
  delivery_shipping_time: {
    title: 'Час доставки',
    comment:
      'Вкажіть скільки в середньому часу потрібно на доставку замовлення.',
  },
  guests_count_flag: {
    title: 'Кількість приборів',
    ask_count: 'Запитувати кількість приборів',
    paid_title: 'Платні прибори',
    paid_comment:
      'Ви можете вказати вартість кожного набору приборів. Загальна вартість приборів буде додана гостю в чек автоматично.',
    paid_ph: 'Ціна 1 набору приборів',
    checkbox:
      'Система QRWaiter може запитувати у Ваших гостей необхідну кількість приборів для замовлення',
  },
  client_card: {
    phone: 'Телефон:',
    address: 'Адреса:',
    bonus_balance: 'Бонусний баланс:',
    average_check: 'Середній чек:',
    total_orders: 'Всього замовлень:',

    option_bonuses: 'Накопичення бонусів',
    option_discount: 'Встановити постійну знижку',

    table_date: 'Дата',
    table_time: 'Час',
    table_discount: 'Знижка',
    table_price: 'Сума',
    table_bonuses: 'Бонуси',
  },
  pay_methods: {
    cash: 'Готівка',
    card: 'Картка',
    online: 'Онлайн',
  },
  workers_table: {
    add_button: 'Додати',
    col_no: '№',
    col_name: `Ім'я`,
    col_pin: `PIN-код`,

    bot_connected: 'Підключений',
    bot_not_connected: 'Не підключений',

    confirm_delete:
      'Ви впевнені що хочете видалити цього працівника? Цю дію неможливо відмінити.',
  },
  worker_profile: {
    new_ph: 'Новий працівник',
    orders_history: 'Історія замовлень',
    tips_history: 'Історія чайових',
    tips_cafe_balance: 'На рахунку закладу',

    phone_ph: 'Номер телефону',
    profile_title: 'Персональна інформація',

    bot_panel_comment:
      'Проскануйте цей QR-код з телефону офіціанта, щоб підключити сповіщення про замовлення.',
    bot_panel_title: 'Сповіщення для офіціантів',
    bot_offline: 'Офіціант вимкнув сповіщення',

    tips_title: 'Баланс чайових',
    tips_comment:
      'Тут відображаються чайові офіціанта, які гості оплатили на рахунок закладу онлайн.',
    tips_payout: 'Зробити виплату',

    tips_card_title: 'Онлайн чайові',
    tips_card_desc:
      'Ваші гості можуть залишати чайові онлайн. Кошти надходидимуть одразу на картку співробітника. Оплата проводиться через P2P переказ.',
    tips_card_input:
      'Вкажіть реквізити співробітника, на які він має отримувати онлайн чайові.',
    tips_technology: `Ви можете вказати реквізити особистої картки офіціанта, щоб він мав змогу отримувати онлайн чайові за замовлення.

        Платіж від клієнта до офіціанта здійснюватиметься за допомогою технології P2P (як звичайний грошовий переказ між двома фіз. особами)`,

    attach_tables_title: "Прив'язка столів",
    attach_all: 'Офіціанту приходять сповіщення про замовлення з усіх столів.',
    attach_none: 'Офіціанту не приходять сповіщення про нові замовлення.',
    attach_certain:
      'Офіціанту приходять сповіщення про замовлення тільки з обраних столів.',

    attach_tables_title_hotel: "Прив'язка номерів",
    attach_all_hotel:
      'Офіціанту приходять сповіщення про замовлення з усіх номерів.',
    attach_none_hotel: 'Офіціанту не приходять сповіщення про нові замовлення.',
    attach_certain_hotel:
      'Офіціанту приходять сповіщення про замовлення тільки з обраних номерів.',

    attach_no_tables: 'У Вас ще не налаштовані зали та столи.',
    attach_setup_tables: 'Налаштувати зали та столи',

    modes_title: 'Сповіщення систем',
    modes_comment:
      'Оберіть системи від яких співробітник буде отримувати сповіщення',

    tipping_title: 'Чайові',
    tipping_cash: 'Готівкою',
    tipping_online: 'Онлайн',
    tipping_comment: `Ваші гості можуть залишати чайові. Відповідна функція з'явиться в системі INSIDE після оплати замовлення.`,
    tipping_merchant:
      'Вкажіть мерчанта, через який будуть здійснюватись транзакції по оплаті чайових.',
  },
  worker_tips_history: {
    col_date: 'Дата',
    col_time: 'Час',
    col_check: 'Чек',
    col_pay: 'Метод оплати',
    col_total: 'Сума',
    col_tip: 'Чайові',
    col_balance: 'Баланс',
    col_discount: 'Знижка',
  },
  online_payment: {
    gateways: {
      comission: 'Комісія',
      pb_target: 'Тільки для клієнтів Приватбанку',
      any_target: 'Для клієнтів будь-якого банку',
      payu_target: 'Для клієнтів банку країн, в яких працює система Payu',
      yookassa_target:
        'Для клієнтів банків країн, в яких працює система ЮКасса',
      stripe_target: 'Для клієнтів банків країн, в яких працює система Stripe',
    },
    start: {
      desc:
        'Ви можете створити інтеграцію з цією платіжною системою, щоб приймати онлайн платежі.',
      action: 'Створити інтеграцію',
    },
    guide: {
      title: 'Інструкція по підключенню',
      part1:
        'Для того, щоб підключити онлайн оплату, Вам потрібно створити аккаунт в платіжній системі.',
      part2:
        'Потім потрібно скопіювати "Публічний API ключ" та "Приватний API ключ", щоб інтеграція налаштувалась автоматично',
      part3:
        'Також, для збуту товарів онлайн, потрібно мати договір публічної оферти. QRWaiter генерує цей договір автоматично. Для цього залиште свої реквізити.',
      part4:
        'Якщо у Вас немає аккаунту мерчанта в цій платіжній системі, Ви можете його зареєструвати.',
      register_btn: 'Зареєструвати мерчанта',
      add_btn: 'Додати мерчанта',
      add_btn_hint:
        'Ви можете додати ще один аккаунт цієї платіжної системи, якщо Вам потрібно щоб кошти за деякі товари з меню зараховувались на інший рахунок.',
    },
    help: {
      title: 'Переглянути інструкцію з підключення',
      liqpay: {
        '0': 'Розпочніть реєстрацію мерчанта, ввівши номер телефону',
        '1':
          'Вкажіть дані про свою компанію. В полі "Веб-адреса" вкажіть посиланння на Ваше онлайн меню:<br><a href="#" class="c-orange">{menuLink}</a>',
        '2':
          'Активуйте компанію, вказавши рахунок, на який будуть зараховуватись кошти',
        '3': 'Скопіюйте ключі API та вставте їх в відповідні поля в QRWaiter',
        '4': 'Активуйте оплату по Apple Pay, додавши домен app.qrwaiter.com.ua',
      },
      wayforpay: {
        '0': 'Натисніть "Підключити" та введіть свій номер телефону.',
        '1': 'Створіть новий магазин та виберіть опцію "Я власник сайту"',
        '2': 'Вкажіть реквізити Вашої компанії',
        '3': 'Заповніть необхідну інформацію та підпишіть необіхдні документи.',
        '4':
          'Скопіюйте реквізити мерчанта (ключі API) у відповідні поля в QRWaiter.',
      },
      yookassa: {
        '0': 'Перейдіть на форму реєстрації',
        '1': 'Введіть свій номер телефону і заповніть інформацію про компанію',
        '2':
          'Створіть тестовий й реальний магазин, та скопіюйте ключі API (публічним ключем виступає shopId). До активації аккаунту Ви можете використовувати тестові ключі API.',
        '3':
          'Увімкніть HTTP сповіщення в налаштуваннях інтеграції та вкажіть URL системи QRWaiter:<br><b>https://qrwaiter.com.ua/api/yookassa/webhook</b>',
        '4':
          'Розпочніть заповнення та підписання документів. В якості посилання на сайт вкажіть посилання на Ваше онлайн меню. Детальніша інформація доступна в <a target="_blank" class="c-green" href="https://yookassa.ru/docs/support/merchant/payments/implement/docs">документації ЮКаси.</a>',
      },
      stripe: {
        '0': 'Перейдіть на сторінку реєстрації',
        '1': 'Введіть свої контактні дані та зареєструйтесь',
        '2': 'Перейдіть до активації аккаунту',
        '3': 'Заповніть необхідні форми та документи',
        '4':
          'Скопіюйте ключі API в QRWaiter. До активації аккаунту Ви можете використовувати тестові ключі для перевірки оплати.',
        '5':
          'Натисніть "Підключити Stripe Webhook" щоб створити вебхук для оплати і завершити інтеграцію.',
      },
    },
    delete_merchant: 'Видалити мерчанта',
    api_keys: {
      title: 'Ключі API',
      public_ph: 'Публічний API ключ',
      private_ph: 'Приватний API ключ',
      invalid_title: 'Вказані ключі API невірні',
      invalid_desc:
        'Ми не змогли підтвердити правильність наданих ключів API. Будь-ласка, перевірте правильність введених даних (зайві символи або помилки копіювання), або звʼяжіться з тех. підтримкою.',
      test_title: 'Ви вказали тестові ключі API',
      test_desc:
        'Ви можете використовувати ці ключі для перевірки онлайн оплати або для проходження процедури активації аккаунту в платіжній системі. Списані кошти при цьому будуть одразу повертатись платнику. Для проведення реальних платежів Вам необхідно вказати "бойові" API ключі. ',
    },
    company_details: {
      title: 'Реквізити компанії',
      type_ph: 'Тип компанії',
      type_physical: 'ФОП',
      type_llc: 'ТОВ',
      name_ph: 'Назва компанії',
      code_ph: 'ЄДРПОУ',
      address_ph: 'Юридична адреса компанії',
      account_ph: 'Розрахунковий рахунок',
      phone_ph: 'Контактний телефон',
      tax_ph: 'ІПН',
      email_ph: 'Електронна пошта',
    },
    add_other_desc:
      'Ви можете додати ще один аккаунт цієї платіжної системи. Якщо Вам потрібно, щоб кошти за деякі товари в меню зараховувались на інший рахунок.',
    add_other_btn: '+ Додати ще одного мерчанта',
    add_other_title: 'Додатковий аккаунт',

    menu_panel: {
      title: 'Меню мерчанта',
      comment:
        'Кошти за оплату страви в обраних меню будуть надходити на реквізити цього мерчанта.',
    },
  },
  modificator_link_modal: {},
  regional_panel: {
    title: 'Регіональні налаштування',
    currency: 'Валюта закладу',
    timezone: 'Часовий пояс',
    language: 'Мова сповіщень',
    round_menu_prices: 'Округлювати ціни в меню',
  },
  system_motd: {
    title: 'Налаштування інтерфейсу для гостей',
    btn_title: 'Назва кнопки на сторінці вибору системи',
    popup_title: 'Назва системи у вітальному вікні',
    motd_title: 'Текст в вітальному вікні',
    ph: 'Напишіть сюди Ваш текст',
    desc_1:
      'Коли Ваші гості відкривають систему {mode}, за замовчуванням вони побачать текст з описом системи, тарифами по доставці та умовами користування.',
    desc_2:
      'Ви також можете додати на цю сторінку спеціальні пропозиції, тарифи та пояснення.',
  },
  chain_general: {
    title: 'Загальна інформація',
    name_ph: 'Назва мережі',
    desc_ph: 'Опис',
  },
  chain_settings: {
    title: 'Централізовані налаштування',
    option_menu: 'Меню',
    option_pos: 'POS-інтеграції',
    option_payment: 'Платіжні системи',
    option_integrations: 'Сторонні інтеграції',

    cafe_modal_title:
      'Оберіть заклад, меню якого потрібно скопіювати і зробити основним в мережі',
    cafe_modal_cancel: 'Відміна',
    cafe_modal_confirm: 'Увімкнути загальне меню',

    comment_1:
      'Ви можете централізовано налаштовувати ці параметри. Тоді зміни будуть застосовані до всіх закладів мережі.',
    comment_2:
      'Функції, в яких вимкнено централізоване налаштування, налаштовуються окремо, в адмін панелі кожного закладу.',
  },
  timing_settings: {
    title: 'Часові налаштування',
    last_order: 'Останнє замовлення',
    last_order_comment:
      'Вкажіть, за скільки хвилин до закриття закладу приймати останнє замовлення.',

    cook_time: 'Найближчий доступний час для замовлення',
    cook_time_desc:
      'Вкажіть мінімальний проміжок часу, необхідний для приготування одного замовлення',

    cook_time_warning:
      'QRWaiter буде відображати для Ваших гостей найближчий час для замовлення з урахуванням цього значення. Але гість всеодно отримає точний час приготування замовлення після того як заклад підтвердить його.',

    delivery_time: 'Час на доставку',
    delivery_time_comment:
      'Вкажіть час, необхідний в середньому для доставки одного замовлення',
    delivery_time_comment2:
      'Це значення буде враховуватись при відображенні часу очікування на замовлення.',

    time_ph: '0 хв',

    gap_warning:
      'При вибраних налаштуваннях гість не зможе обрати час та не зможе відправити для замовлення.',
  },
  user_contacts: {
    title: 'Мої контакти',
    name_ph: `Ім'я`,
    phone_ph: 'Номер телефону',
  },
  stickers_static: {
    title: 'Стікери',
    subtitle_none: 'Для початку роботи системи потрібно замовити стікери',
    subtitle_ready: 'Стікери активовані і готові до роботи ✅',

    comment_none:
      'Для роботи системи {mode} потрібні спеціальні стікери. На кожен стіл генерується стікер з унікальним QR-кодом, щоб система розпізнавала столи.',
    comment_none2:
      'Ви можете замовити стікери в QRWaiter або ж роздрукувати їх самостійно',

    button: 'Замовити дизайнерські стікери',
    download: 'Завантажити QR-коди',
  },
  system_progress_bar: {
    not_active: 'Готовніть системи',
    active: 'Система налаштована і готова до роботи',
    suspended: 'Система не оплачена',
    needed: 'Для старту роботи системи, потрібно:',
    hint:
      'Ви можете натиснути на потрібний блок для швидкого переходу до налаштувань.',
  },
  store_card: {
    inside: [
      'Онлайн оплата',
      'Онлайн чайові',
      'Замовлення страв та послуг',
      'Автоматичний переклад',
      'QRWaiter AI ®',
      'Перевірка геолокації',
      'Автоматичне розпізнавання столів',
      'Інтеграція з POS-системами',
      'Формування клієнтської бази',
    ],
    delivery: [
      'Онлайн оплата',
      'Замовлення страв',
      'Автоматичний переклад',
      'QRWaiter AI ®',
      'Інтеграція з POS-системами',
      'Інтеграція з службами доставки',
      'Налаштування зон доставки',
      'Гнучкі налаштування умов та тарифів',
      'Формування клієнтської бази',
    ],
    preorder: [
      'Онлайн оплата',
      'Замовлення страв',
      'Автоматичний переклад',
      'QRWaiter AI ®',
      'Інтеграція з POS-системами',
      'Формування клієнтської бази',
    ],
    reserve: [
      'Онлайн оплата',
      'Депозит',
      'Система безпечних бронювань',
      'Календар бронювань',
      'Інтеграція з POS-системами',
      'Формування клієнтської бази',
    ],
    hotels: [
      'Перевірка геолокації',
      'Автоматичне розпізнавання номерів',
      'Замовлення страв та послуг',
      'QRWaiter AI ®',
      'Інтеграція з POS-системами',
      'Формування клієнтської бази',
    ],

    pro_title: 'Всі системи та можливості QRWaiter в одній підписці',
    pro_long: 'Всі системи та можливості QRWaiter в одній підписці',

    stickers_required: '* Для користування потрібно замовити QR-стікери',

    inside_long:
      'Цифрове меню всередині закладу, яке працює за допомогою QR-кодів з прив’язкою до столів. Гості закладу сканують QR-код, отримують доступ до меню та роблять замовлення. Замовлення приходить на POS-термінал, а офіціант отримує відповідне сповіщення. Також гостям доступні додаткові послуги та онлайн оплата замовлення.',
    delivery_long: 'Система для організації власної доставки',
    reserve_long: 'Система для прийому бронювань.',
    preorder_long:
      'Система для попередніх замовлень в режимі "на виніс" або ж з бронюванням столу',
    hotels_long:
      'Система для отелів, яка допомагає оцифрувати замовлення їжі, напоїв та навіть послуги рум-сервісу.',

    system_status: 'Статус системи',
    connected: 'Підключена',

    subscription_status: 'Статус підписки',
    trial_until: 'Пробний період до',
    paid_until: 'Оплачена до',
    recurring_payment: 'увімкнене автоматичне списання',
    ended_at: 'Закінчилась',

    disconnect: 'Відключити систему',
    subscribe: 'Оформити підписку',

    cancel: 'Відмінити підписку',
    change_card: 'Змінити карту для оплати',

    trial_bonus:
      'При оплаті в день підключення системи, вам буде надано додатковий тиждень підписки в якості бонусу.',

    details: 'Детальніше',
    connect: 'Підключити',
    month: 'місяць',
  },
  new_store_card: {
    subscription_status: 'Статус підписки',
    system_status: 'Статус системи',

    status_active: 'Активна',
    status_inactive: 'Не активна',
    status_subscribed: 'Оформлена',
    status_not_subscribed: 'Не оформлена',
    status_pending_approval: 'Очікує підтвердження від банку',

    next_payment: 'Дата наступного платежу',

    ended_at: 'Закінчилась',

    free: 'БЕЗКОШТОВНО',
    freemium_note:
      'По закінченню пробного періоду потрібно буде оформити підписку для продовження користування системою {mode}',
    trial_period: 'Пробний період',
    freemium_count: 'Безкоштовні замовлення',
    freemium_limit:
      'Для продовження роботи системи {mode} потрібно оформити підписку',

    subscribe_btn: 'Оформити підписку',
    cancel_btn: 'Скасувати підписку',
    change_card_btn: 'Змінити карту для оплати',
    update_payment: 'Оновити платіжну інформацію',

    reconfirm_cancel:
      'Ви вимкнули систему {mode}, але підписка залишиться активною. Ви бажаєте скасувати підписку?',
    reconfirm_btn_confirm: 'Так, скасувати підписку',
    reconfirm_btn_cancel: 'Ні',

    paid_till: 'Оплачено до',
    connected_card: 'Підключена картка',

    paid_text:
      'Ваша підписка була скасована, але Ви можете використовувати систему {mode} до кінця проплаченого періоду',

    recurring_enabled: 'Платіж буде проведено автоматично',
    recurring_failed:
      'Останній платіж не вдався. Будь ласка, оновіть платіжні дані. Ваша система буде відключена через {days} дн.',
  },
  new_systems_features: {
    custom_page: ['🚀 Особиста сторінка закладу', 'Web Mobile | Web Desktop'],
    menu_translation: ['🌍 Автоматичний переклад меню'],
    pos_integration: [
      '🔗 Синхронізація з POS-системою',
      `• Імпорт меню, залів та столів, персоналу <br>
          • Синхронізація замовлень в режимі онлайн <br>
          • Синхронізація меню - фото, ціни, тех карти, залишки`,
    ],
    orders_panel: [
      `📱 Панель замовлень`,
      `Додаток для персоналу | iOS / Android`,
    ],
    inside_orders: [
      '🚀 Замовлення всередині закладу',
      'Система працює через QR-коди та автоматично розпізнає столи',
    ],
    online_payment: [
      '💳 Інтеграція з платіжними системами',
      'Для оплати замовлень онлайн | Apple Pay / Google Pay',
    ],
    online_tips: ['💸 Онлайн чайові для персоналу'],
    ai: ['🤖 QRWaiter AI', 'Рекомендації страв на базі машинного навчання'],
    crm: ['👥 CRM', 'Формування власної клієнтської бази'],
    delivery_orders: [
      '🛵 Замовлення з доставкою',
      'Налаштування всього процесу замовлення',
    ],
    takeaway_orders: [
      '🌯 Замовлення з собою',
      'Налаштування всього процесу замовлення',
    ],
    sms_verification: ['🔒 Верифікація клієнтів по СМС'],
    push_notifications: ['🔔 Push-сповіщення при зміні статусу замовлення'],
    reserve_orders: [
      '🛎 Бронювання столів</b><br>Налаштування всього процесу замовлення',
    ],
    reserve_deposit: ['💰 Депозит для бронювання</b>'],
    reserve_calendar: ['🗓 Календар бронювань</b>'],

    pro_inside_orders:
      '<b>🚀 Замовлення всередині закладу</b><br>Система INSIDE',
    pro_delivery_orders: '<b>🛵 Замовлення з доставкою</b><br>Система DELIVERY',
    pro_takeaway_orders: '<b>🌯 Замовлення з собою</b><br>Система TAKEAWAY',
    pro_reserve_orders: '<b>🛎 Бронювання столів</b><br>Система RESERVE',
  },
  stickers_card: {
    custom_comment:
      'Ви можете завантажити шаблон, на базі якого можна створити власний унікальний дизайн.Також Ви можете замовити в нас розробку унікального дизайну для Вашого закладу.',
    download: 'Шаблон',
    format_svg: 'Формат файлу має бути .svg',
    choose_system_ph: 'Оберіть систему',
    choose_system: 'Оберіть систему, для якої бажаєте замовити стікери',
    different_halls: 'Ви можете замовити різні стікери для різних залів',
    add_btn: 'Додати в кошик',
    choose_file: 'Оберіть файл...',
    upload_custom: 'Завантажити власний дизайн',
    uploaded: 'Завантажено',
    direct_sticker: 'Звичайні',
    added: 'Додано',
    count: 'Вкажіть кількість стікерів, яку бажаєте замовити',
    count_ph: 'Кількість стікерів',
    hall_ph: 'Зал',
    all_halls: '- Всі зали -',
    tables_suffix: 'столів',
    stickers_suffix: 'стікерів',
    inside_sticker: 'Для столів',
  },
  stickers_checkout: {
    title: 'Кошик',
    contacts: 'Контакти',
    order: 'Замовлення',
    fullname_ph: 'ПІБ отримувача',
    firstname_ph: `Ім'я`,
    lastname_ph: 'Прізвище',
    middlename_ph: 'По-батькові',
    phone_ph: 'Номер телефону',
    delivery_ph: 'Оберіть спосіб доставки',
    novaposhta: 'У відділення "Нової Пошти"',
    warehouse: 'Відділення Нової Пошти',
    language: 'Мова стікерів',
    address: 'Адреса',
    courier: `Кур'єром`,
    comment: 'Коментар до замовлення',
    pay: 'Оплатити замовлення',

    total: 'Всього:',

    direct_title: 'Звичайний QR-код',

    col_design: 'Дизайн',
    col_language: 'Мова',
    col_hall: 'Зал',
    col_table: 'Стіл',
    col_count: 'Кількість стікерів',
    col_count_sub: 'для одного столу',
    col_price: 'Вартість',

    pay_hint: 'Ваше замовлення буде відправлено на друк після повної оплати',
  },
  shipments_table: {
    statuses: {
      preparing: 'Друкується',
      shipping: 'В дорозі',
      returned: 'Повернено',
      shipped: 'Виконано',
    },
    recipient: 'Отримувач',
    delivery: 'Адреса доставки',
    contents: 'Вміст',
  },
  cafe_fill_profile: {
    comment:
      'Щоб максимально ефективно використати всі можливості QRWaiter, налаштуйте такі функції:',

    params: {
      contacts: 'Контакти закладу в меню',
      online_payment: 'Онлайн оплата',
      translations: 'Переклади в меню',
      photos: 'Фото на всіх стравах',
      descriptions: 'Опис страв',
    },

    filled_at: 'Профіль закладу заповнено на',
  },
  onboarding: {
    welcome: 'Дякуємо що обрали QRWaiter!',
    get_started:
      'Для початку роботи Вам необхідно внести загальну інформацію про Ваш заклад.',

    step_1:
      'Загрузіть логотип, вкажіть назву та короткий опис Вашого закладу. Також оберіть цінову політику (рівень цін)',

    next: 'Далі',
    back: 'Назад',

    name_ph: 'Назва закладу',
    desc_ph: 'Опис закладу',
    price_ph: 'Цінова політика',
    type_ph: 'Тип закладу',
    type_cafe: 'Заклад громадського харчування (кафе, ресторан, фудтрак)',
    type_hotel: 'Готель',

    step_2_comment:
      'Вкажіть вулицю, номер будинку, місто. Ви також можете відкорегувати адресу, відитивши потрібне місце на мапі.',
    step_2: 'Тепер вкажіть адресу закладу',

    address_ph: 'Адреса',

    step_3_comment: 'Вкажіть в які дні працює Ваш заклад',
    step_3: 'Графік роботи закладу',

    step_4: 'Майже готово!',
    step_4_comment: 'Залишилось обрати валюту, часовий пояс та мову сповіщень.',
    step_4_hint:
      'Сповіщення для персоналу, СМС-сповіщення для гостей, сповіщення для адміністратора.',

    done: 'Чудово!',
    done_comment:
      'Тепер Ваш заклад готовий до роботи! Обирайте необхідні системи, налаштовуйте їх та збільшуйте кількість замовлень в рази!',

    finish: 'Обрати системи',
  },
  subscribe_period: {
    title: 'Оберіть період підписки',
    period: 'ПЕРІОД',
    month: 'місяць | місяців',
    price: 'ВАРТІСТЬ 1 МІСЯЦЯ',
    total: 'ДО СПЛАТИ',
    profit: 'ВИГОДА',
    pay: 'Оплатити',
  },
  delivery_courier_delay: {
    title: `Нагадування про виклик кур'єра`,
    desc: `Увімкніть цю опцію, щоб персонал завчасно отримував сповіщення про необхідність замовити кур'єра або машину для замовлень на доставку`,
    ph: '0 хв',
    desc_on:
      "Вкажіть, за скільки хвилин до відправки замовлення присилати сповіщення про виклик кур'єра",
  },
  waiter_schedule: {
    title: 'Відправляти сповіщення про замовлення',
    tab_always: 'Завжди',
    tab_schedule: 'За графіком',
    day_noun: '{n}-й день',
    workday: 'Робочий',
    freeday: 'Вихідний',
    add_btn: 'Додати день',
    desc_on:
      'Вкажіть порядок змін працівника. Якщо працівник працює кожен другий день, достатньо буде додати 2 дні та вказати другий день як“ робочий”, тоді система автоматично запланує його зміну на кожен другий день.',
    desc_off:
      'Налаштуйте графік роботи працівника, щоб сповіщення про нові замовлення надходили йому тільки в робочі дні.',
    start_date: 'Дата початку дії чергувань:',
  },
  security_panel: {
    title: 'Безпека',
    phone: 'Перевіряти номера телефонів гостей за допомогою SMS',
  },
  loyalty_view: {
    placeholder: 'Вкажіть розмір бонусу',
    desc:
      'Програма лояльності для ваших гостей. Ви можете нараховувати від 1 до 5 відсотків бонусних балів від суми кожного замовлення. Згодом клієнт може за ці бонуси розрахуватись за замовлення, але за умови що у нього буде достатньо бонусів для цього. Замовлення можна оплатити тільки за умови що сума замовлення не перевищує суму бонусів.',
    stats: 'Статистика',
    bonuses_total: 'Бонусів накопичено',
    bonuses_used: 'Бонусів використано',
  },
  campaigns_view: {
    title: 'Рекламна кампанія',
    add_btn: 'Додати рекламну кампанію',
    desc:
      'Створюйте посилання для різних рекламних кампаній та відслідковуйте їх ефективність',
  },
  campaign_card: {
    status: 'Статус:',
    active: 'Активна',
    not_active: 'Неактивна',
    period: 'Термін дії:',
    link: 'Посилання:',
    download_qr: 'Завантажити QR-код посилння',

    stat_visits: 'Кількість переходів',
    stat_unique: 'Унікальних користувачів',
    stat_orders: 'Замовлень',
    stat_sum: 'Сума замовлень',
  },
  add_campaign: {
    title: 'Створення рекламної кампанії',
    name_ph: 'Назва рекламної кампанії',
    start_ph: 'Дата початку',
    end_ph: 'Дата кінця',

    cancel: 'Скасувати',
    confirm: 'Створити',
  },
  promocode_add_modal: {
    show_btn: 'Згенерувати промокод',

    title: 'Генерація промокоду',
    max_limit: 'Максимальна кількість застосувань на 1 клієнта',

    tab_single: 'Один багаторазовий',
    tab_multi: 'Декілька одноразових',
    count_ph: 'Кількість кодів',
    custom_ph: 'Промокод (залише пустим щоб згенерувати автоматично)',
    type_ph: 'Тип промокоду',
    discount_ph: 'Знижка (%)',
  },
  promocode_types: {
    dish_discount: 'Знижка на страву',
    check_discount: 'Знижка',
    free_delivery: 'Безкоштовна доставка (DELIVERY)',
  },
  promocode_group_card: {
    used_count: 'Кількість застосувань',
    copy_btn: 'Скопіювати промокод',
    view_btn: 'Переглянути промокоди',
    count_ph: 'Кількість промокодів',
    code_ph: 'Промокод',

    delete_confirm: `Ви впевнені, що хочете видалити цей промокод?`,
  },
  promocodes_table: {
    title: 'Список промокодів',
    col_code: 'Код',
    col_name: `Ім'я клієнта`,
    col_phone: 'Телефон клієнта',
    col_status: 'Статус',
    status_used: 'Використаний',
    status_not_used: 'Не використаний',
    col_date: 'Дата використання',
    export_btn: 'Експорт',
  },
  demo_qrcode: {
    title: 'Демо-режим',
    title_normal: 'Онлайн меню',
    text:
      'Відскануйте цей QR-код, щоб переглянути меню та зробити тестове замовлення.',
  },
  stats_summary: {
    guests: 'Кількість гостей',
    orders: 'Кількість замовлень',
    average: 'Середній чек',
    income: 'Дохід',
  },
  stats_chart: {
    title: 'Замовлення',
    conversion: 'Конверсія',
    day: 'День',
    week: 'Тиждень',
    month: 'Місяць',

    label_orders: 'Кількість замовлень',
    label_views: 'Кількість переходів',
    label_bounce: 'Конверсія (%)',
  },
  stats_histogram: {
    orders_title: 'Середня кількість замовлень',
    hour: 'По годинам',
    day: 'По дням',

    average_title: 'Середній чек',
    guests_title: 'Середня кількість гостей',
    finances_title: 'Середній показник прибутку',

    menus: 'По меню',
    sections: 'По залам',
  },
  stats_income_sources: {
    title: 'Структура доходу',
    by_system: 'Системи',
    by_menu: 'Меню',
    by_waiter: 'Офіціанти',
    by_halls: 'Зали',
  },
  stats_top_guests: {
    title: 'Топ 10-гостей',
    col_name: 'Клієнт',
    col_orders: 'Замовлень',
    btn_all: 'Переглянути список клієнтів',
  },
  stats_circle: {
    total: 'ВСЬОГО',
    accepted: 'ПРИЙНЯТИХ',
    cancelled: 'СКАСОВАНИХ',
  },
  stats_paymethods: {
    title: 'Спосіб оплати',
  },
  stats_ratios: {
    title: 'Співвідношення по системам',
  },
  alerts: {
    file_too_large:
      'Вибраний файл занадто великий. Максимальний обсяг файлу: 15 МБ',
  },
  dish_photo_editor: {
    title: 'Редактор фото',
    hint:
      'Відредагуйте фото для всіх форматів так, щоб не було видно сірого фону.',
    button_change: 'ЗМІНИТИ',
    button_rotate: 'ПОВЕРНУТИ',
    button_auto: 'АВТО',

    button_save: 'ЗБЕРЕГТИ',

    formats: 'Формати',
    format_1: '1х1 (картка страви)',
    format_2: '16х9 (картка страви)',
    format_3: '4х1 (фоновое зображення)',

    cancel: 'Скасувати',
    process: 'Зберегти',
  },
  add_discount: {
    btn: 'Додати акцію',
    title: 'Створення акції',
    all_categories: '- всі категорії -',
    all_products: '- всі страви -',
    all_modificators: '- всі модифікатори -',
    all_menus: '- всі меню -',
    discount_ph: 'Знижка (%)',
  },
  discount_card: {
    delete_btn: 'Видалити акцію',
    period: 'Період дії:',
    period_from: 'з {start}',
    period_to: 'по {end}',

    applies_to_menu: 'Застосовується на меню {menu}',
    applies_to_category: 'на категорію {category}',
    applies_to_product: 'на страву {product}',

    size: 'Розмір:',
    title: 'Знижка',
    conditions: 'Умови:',
  },
  tables_grid: {
    heatmap: 'Теплова карта столів',
    add_table: 'Додати стіл',

    avg_orders: 'Середня кількість замовлень в день',
    avg_sum: 'Середній чек в день',
    avg_guests: 'Середня кількість гостей в день',
  },
  notification_toast: {
    error: 'Помилка',
    info: 'Інформація',
    support: 'Тех. підтримка',

    confirm: {
      copied: 'Скопійовано',
      saved: 'Зміни збережено',
    },
  },
  client_profile: {
    general_title: 'Загальна інформація',
    phone: 'Телефон:',
    address: 'Адреса:',

    bonuses_title: 'Накопичення бонусів',
    bonuses_desc: 'Ви можете увімкнути постійне накопичення бонусів для гостя',

    discount_title: 'Постійна знижка',
    discount_desc: 'Ви можете встановити постійну знижку для даного гостя',

    summary_title: 'Загальна статистика',
    summary_average: 'Середній чек',
    summary_total: 'Замовлень на суму',
    summary_orders: 'Всього замовлень',
    summary_bonuses: 'Бонусний баланс',
    summary_period: 'Періодичність замовлень',

    summary_top_dishes: 'ТОП-3 страви:',
  },
  reminder_timeout_panel: {
    title: 'Сповіщення про неприйняте замовлення',
    comment:
      'Ви можете отримувати сповіщення коли персонал довго не приймає замовлення',
  },
  auto_cancel_panel: {
    title: 'Автоматичне скасування замовлення',
    comment:
      'Вкажіть час (у хвилинах), через який замовлення буде скасовано автоматично якщо персонал не буде на нього реагувати. Гостю також прийде сповіщення про те що його замовлення не прийняли вчасно.',
  },
  preorder_time_flag: {
    title: 'Замовлення наперед',
    desc:
      'З цією опцією гості зможуть зробити замовлення на декілька днів наперед. Якщо ж ця опція вимкнена, всі замовлення будуть робитись "якнайшвидше".',
  },
  poster_pending_changes: {
    title: 'Доступні нові зміни',
    desc:
      'Ми зафіксували зміни в Poster. Оберіть, які з них потрібно прийняти або проігноруйте їх.',

    new_product_suffix: 'нова страва',
    new_price_group_suffix: 'нова група модифікаторів',
    new_price_group_item_suffix: 'новий модифікатор',
    remove_price_group_suffix: 'видалено групу модифікаторів',

    ignore_btn: 'Ігнорувати',
    accept_btn: 'Прийняти',
  },
  danger_confirm_modal: {
    default_confirm: 'Підтвердити',
    default_cancel: 'Скасувати',
    default_title: 'Підтвердження',
  },
  info_modal: {
    default_title: 'Інформація',
  },
  orders_panel_download: {
    title: 'Завантажте додаток для прийому замовлень',
    id_hint: 'ID закладу:',

    web_hint: `Панель замовлень, яка працює через веб-браузер на комп'ютері, планшеті та смартфоні`,
    telegram_hint: 'Налаштовується в профілі кожного працівника',

    btn_copy: 'Копіювати посилання',
    btn_qr: 'Показати QR-код',
    btn_open: 'Відкрити',
    btn_setup: 'Налаштувати',
    btn_download: 'Завантажити',
  },
  integrations_market: {
    categories: {
      pos_systems: 'POS системи',
      payment_gateways: 'Платіжні системи',
      menu: 'Меню',
      delivery_partners: 'Доставка',
      analytics: 'Маркетинг та аналітика',
    },
    page: {
      about: 'Опис',
      screenshots: 'Скріншоти',
      contacts: 'Контакти',

      connect: 'Підключити',
      connected: 'Підключено',
      disconnect: 'Відключити',
    },
    editor: {
      edit: 'Редагувати',
      save: 'Зберегти зміни',

      name_ph: 'Назва інтеграції',
      short_ph: 'Короткий опис',
      desc_ph: 'Опис',
      price_hint: 'Вкажіть вартість інтеграції',
    },
  },
  mobile_blocker: {
    title: 'Панель адміністратора недоступна на мобільних пристроях.',
    desc: `Будь ласка, відкрийте панель адміністратора на Вашому комп'ютері.`,
  },
  quickstart_options: {
    digital_menu: 'Цифрове меню з можливістю замовляти всередині закладу',
    online_pay_inside: 'Онлайн оплата замовлень в закладі',
    waiter_call: 'Альтернатива кнопки виклику офіціанта',
    takeaway: 'Система для прийому замовлень "з собою"',
    pager_alt: 'Альтернатива "пейджерам" на фуд корті',
    custom_delivery: 'Організація власної доставки',
    phone_alt: 'Альтернатива замовлень по телефону',
    reservations: 'Бронювання столів',
    kiosk: 'Цифрове меню в режимі перегляду без можливості зробити замовлення',
  },
  quickstart_score: {
    desc: 'Ваш рейтинг використання QRWaiter',
  },
  quickstart_static: {
    title: "Панда К'ю від QRWaiter",
    pt1: 'Майже готово!',
    pt2: 'Продовжуйте налаштування, щоб отримати максимум від QRWaiter',
  },
  quickstart_survey: {
    title: 'Підбір систем QRWaiter',
    done: 'Готово',

    steps: '2 кроки',
    eta: 'близко 2 хв',

    motd: 'Визначте, які системи найкрайще підійдуть для Вашого закладу.',
    start_btn: 'Пройти опитування',
    skip_btn: 'Відмітити як виконано',

    select: 'Оберіть, які завдання Ви би хотіли вирішити за допомогою QRWaiter',

    confirm_btn: 'Підтвердити',

    connect_btn: 'Підключити необхідні системи',
    last_comment: 'Після підключення систем, Вам потрібно буде налаштувати їх',
  },
  quickstart_setup: {
    setup_btn: 'Налаштувати',
    pending: 'Виконайте всі кроки щоб активувати систему',
    ready: 'Система <span class="bold">{system}</span> готова до використання',
  },
  regular_report: {
    title: 'Регулярний звіт',
    desc: 'Ви можете отримувати звіти по діяльності закладу',

    select_period: 'Оберіть періодичність звіту',

    daily: 'Щоденний',
    weekly: 'Щотижневний',
    monthly: 'Щомісячний',

    select_channel: 'Оберіть куди Ви бажаєте отримувати звіт',
    channel_telegram: 'Telegram (Business bot)',
    channel_email: 'Електронна пошта',
  },
  password_scores: {
    0: 'Дуже слабкий пароль 🤕',
    1: 'Слабкий пароль 🤕',
    2: 'Достатньо сильний пароль 💪',
    3: 'Сильний пароль 💪',
    4: 'Такий пароль неможливо підібрати 🤖',
  },
  register: {
    title: 'Реєстрація',
    name_ph: `Ваше ім'я`,
    email_ph: 'Електронна пошта',
    phone_ph: 'Номер телефону',
    cafe_ph: 'Назва закладу',
    address_ph: 'Адреса закладу',

    mail_sent:
      'На пошту <span class="bold">{email}</span> було відправлено лист з підтвердженням реєстрації.',
    change_mail: 'Змінити пошту',

    action: 'Зареєструватись',

    or: 'або',

    via_poster: 'Зареєструватись через Poster',

    terms_agree:
      'Я ознайомився та погоджуюсь з Політикою конфіденційності та Умовами використання',
  },
  password_recovery: {
    title: 'Відновлення доступу',

    restore_btn: 'Відновити доступ',
    back_btn: 'Повернутись',

    sent_mail:
      'Лист з подальшими інструкціями було відправлено на вказану електронну адресу',
  },
  tax_selector: {
    title: 'Податок',
    no_tax: '- на застосовувати податок -',
    use_parent: 'застосовувати податок меню',
    menu_comment: 'Ви можете застосувати податок на це меню',
    comment: 'Ви можете застосувати податок на цю страву',
  },
  taxes: {
    col_name: 'Назва',
    col_percent: 'Відсоток',
    col_type: 'Тип',

    type_none: 'Без податку',
    type_sales: 'На обіг',
    type_vat: 'ПДВ',

    formula_hint: 'Формула розрахунку:',

    formula_sales: 'Податок = Ціна страви * Відсоток податку',
    formula_vat: 'Ціна з ПДВ = Ціна страви + (Ціна страви * Відсоток податку)',

    add_tax: 'Додати податок',

    save_btn: 'Зберегти',

    confirm_delete: 'Ви впевнені, що хочете видалити вибраний податок?',
  },
  poster_missing_dishes: {
    title: 'Зверніть увагу',
    text:
      "Деякі страви в цьому меню не мають відповідно прив'язаної тех. карти з системи Poster.",
    view: 'Переглянути',
  },
  order_status_notification: {
    title: 'Сповіщення про статус замовлення',
    subtitle: 'Відправляйте гостям сповіщення про замовлення',

    push_title: 'Push-сповіщення',
    push_desc:
      'Цей тип сповіщень безкоштовний і буде відправлений лише тоді коли у користувача є встановлений додаток QRWaiter. Якщо у користувача немає додатку, сповіщення він не отримає',

    sms_title: 'SMS-сповіщення',
    sms_desc:
      'Цей тип сповіщень платний і буде відправлений лише коли у користувача не встановлений додаток QRWaiter.',
  },
  current_balance: {
    title: 'Поточний баланс',
    amount_ph: 'Введіть суму',
    btn_topup: 'Поповнити',
  },
  sms_pricing_terms: {
    title: 'Цінова політика',
    desc:
      'Ціна SMS залежить від регіону номера телефону клієнта. Ви можете переглянути вартість для кожного регіону в таблиці нижче.',
    price: 'Ціна за 1 SMS',
    region: 'Регіон',
  },
  balance_table: {
    col_date: 'Дата',
    col_time: 'Час',
    col_category: 'Категорія',
    col_description: 'Опис',
    col_amount: 'Сума',
    col_balance: 'Баланс',

    recent: 'Останні транзакції',
    btn_see_all: 'Переглянути всі транзакції',

    categories: {
      sms: 'SMS',
      balance_topup: 'Поповнення',
      marketplace_order: 'Замовлення Marketplace',
    },

    sms_types: {
      order_notification: 'Сповіщення про статус замовлення',
      phone_authorization: 'Авторизація клієнта',
      security_alert: 'Сповіщення безпеки',
    },

    outcome_stats: 'Статистика витрат',
  },
  sms_categories: {
    title: 'Категорії SMS',
    active: 'Активно',
    inactive: 'Неактивно',

    order_status: 'Сповіщення про статус замовлення',
    customer_verify: 'Верифікація клієнта по номеру телефона',
    pending_orders: 'Сповіщення про неприйняті замовлення',
    security: 'Сповіщення безпеки',
    marketing: 'Маркетингові розсилки',

    btn_setup: 'Налаштувати',
  },
  nomenculature_packaging: {
    btn_add: 'Додати упаковку',

    col_name: 'Назва',
    col_price: 'Ціна',
    col_weight: 'Максимальна вага',

    col_tax: 'Податок',
    col_volume: `Об'єм`,

    param_pos_id: 'Відповідний елемент номенкулатури в POS системі',

    btn_save: 'Зберегти',
    confirm_remove: 'Ви впевнені, що хочете видалити цю упаковку?',
  },
  packaging_attachment: {
    no_default: '- без упаковки -',
    default_title: 'Упаковка по-замовчуванню',
    price_hint: 'Ціна: {price} {currency} | Податок: {tax}%',

    custom_btn: 'Додати нестандартну',
  },
  add_custom_package: {
    title: 'Нестандартна упаковка',
    subtitle:
      'Виберіть унікальну конфігурацію страви та вкажіть упаковку для неї',

    price: 'Ціна',
    total_weight: 'Вага',

    name_ph: 'Назва нестандартної упаковки',
    package_ph: 'Виберіть упаковку',
    btn_add: 'Додати нестандартну упаковку',

    combination_exists: 'Вибрана конфігурація модифікаторів вже існує',
  },
  sms_history: {
    btn_open: 'Переглянути історію SMS',

    col_date: 'Дата',
    col_time: 'Час',
    col_type: 'Тип',
    col_text: 'Текст',
    col_segments: 'Сегментів',
    col_receiver: 'Отримувач',
    col_cost: 'Вартість',
    col_balance: 'Баланс',
  },
  client_authorization: {
    title: 'Авторизація номеру телефону через SMS',
    subtitle:
      'Ми отправимо унікальний код клієнту для перевірки номеру телефону',

    text1:
      'Це платна функція. Вартість кожної SMS буде списано з вашого балансу автоматично.',
    text2: `Ми використовуємо метод смарт-верифікації - наша система запам'ятовує пристрій користувача з якого був підтверджений номер телефону, що зменшує загальну кількість SMS`,
  },
  system_card: {
    active: 'Активна',
    inactive: 'Неактивна',
  },
  subscription_status_panel: {
    motto_inside: 'Система для замовлень всередені закладу',
    motto_preorder: 'Система для замовлень на виніс',
    motto_delivery: 'Система для замовлень з доставкою',
    motto_reserve: 'Система для бронювання столів',
    motto_preview: 'Система для цифрового меню в режимі вітрини',

    promo_title: 'Вітаємо!',
    promo_text:
      'Вам доступні 14 днів пробного періоду щоб протестувати систему',
    promo_warn:
      'Зверніть увагу, після початку пробного періоду, Ви не зможете його зупнити',

    btn_trial: 'Активувати пробний період',
    btn_subscribe: 'Оформити підписку',
    btn_cancel: 'Скасувати підписку',
    btn_cancel_approval: 'Скасувати підтвердження картки',
    btn_change_card: 'Змінити картку',
    btn_view_invoices: 'Переглянути квитанції',
    btn_renew: 'Оновити підписку',

    param_status: 'Статус підписки',
    param_subscription: 'Підписка',
    param_trial: 'Пробний період',
    param_paid: 'Скасована',
    param_card: 'Підключена картка',
    param_date: 'Дата наступної оплати',

    period_year: 'Щорічна',
    period_month: 'Щомісячна',

    trial_end: 'Закінчився',
    days_left: 'дн. залишилось',
    status_approval: 'Очікуємо підтвердження від банку',

    paid_period: 'Оплачений період | До',

    desc_trial:
      'Після завершення пробного періоду, Вам необхідно буде оформити щомісячну підписку, щоб продовжити використання системи',
    desc_trial_end:
      'Ваш пробний період закінчився. Оформіть підписку, щоб продовжити користуватись системою',
    desc_approval: 'Ваша система буде активна як тільки ми обробимо Ваш платіж',
    desc_active: '* Списання коштів буде зроблено автоматично',
    desc_paid:
      'Ваша підписка була скасована, але Ви все ще можете використовувати систему {system} до кінця оплаченого періоду',
    desc_failed:
      'Провести Ваш щомісячний платіж не вдалось. Ми спробуємо списати кошти ще 3 рази (по спробі в день). В інакшому випадку, Вашу підписку буде скасовано.',

    feedback_text:
      'Ми будемо вдячні, якщо Ви поділитесь Вашим досвідом використання QRWaiter',
    feedback_btn: 'Залишити відгук',

    ended_title: 'Закінчилась',

    ended_thanks: 'Дякуємо!',
    ended_subtitle: 'Ми були раді з Вами працювати',

    failed_attempt_1: '1-ша спроба оплати',
    failed_attempt_2: '2-га спроба оплати',
    failed_attempt_3: '3-тя спроба оплати',
    failed_attempt_4: '4-та спроба оплати',

    charge_later:
      'Якщо Ви оформите підписку зараз, перше списання коштів ми проведемо по закінченню тестового періоду',
  },
  pos_sync_tooltip: {
    title: 'POS-синхронізація',

    btn_sync: 'Синхронізувати',

    manual_sync: 'Ручна синхронізація',
    manual_sync_desc: 'Ви можете примусово синхронизувати меню з POS-системою',
    manual_done: 'Готово',

    menu_sync: 'Авто-синхронізація',
    menu_sync_desc:
      'Система буде перевіряти зміни в POS-системі і автоматично оновлювати їх',
    storage_sync: 'Залишки на складі',
    storage_sync_desc:
      'Ви можете синхронізувати меню з залишками на складі. Тільки наявні страви будут показуватись в меню.',
  },
  pos_pending_changes_tooltip: {
    title: 'Історія змін',
    tab_new: 'Нові',
    tab_ignored: 'Проігноровані',

    type_added: 'Додано',

    no_changes: 'Всі зміни прийнято',
    no_changes_sub: 'Додаткових дій не потрібно',

    btn_select_all: 'Вибрати всі',
  },

  iqos_actions: {
    save: 'Зберегти',
  },

  pos_storage_leftovers_popup: {
    title: 'Сховані позиції',

    items_hidden:
      'У Вас є {count} схованих страв в меню через ввімкнену синхронізацію залишків',
    choose_action: 'Будь ласка, оберіть що Ви бажаєте з ними зробити',

    btn_hide: 'Залишити прихованими',
    btn_show: 'Показати в меню',
  },

  checklists: {
    btn_new: 'Нова форма',
    search_ph: 'Пошук...',
    filter_all: 'Всі',
    forms_noun: '{n} форма | {n} форм',
    last_edited: 'Останнє редагування',
    tab_forms: 'Форми',
    tab_reports: 'Звіти',
  },

  checklist_editor: {
    new_ph: 'Нова форма',
    badge_draft: 'Чорновик',
    badge_live: 'Опубліковано',
    badge_edited: 'Змінено',

    tab_content: 'Контент',
    tab_schedule: 'Графік',
    tab_assign: 'Призначення',

    btn_delete: 'Видалити форму',
    btn_copy: 'Копіювати форму',
    btn_save: 'Зберегти зміни',
    btn_publish: 'Опублікувати',
    btn_unpublish: 'Зняти з публікації',
    btn_preview: 'Попередній перегляд',

    add_tag_ph: 'Додати тег...',

    title_ph: 'Назвіть Вашу форму...',
    desc_ph: 'Опишіть Вашу форму...',

    type_scheduled: 'Запланована',
    type_adhoc: 'Постійна',

    type_scheduled_desc: 'Форма буде доступна по графіку',
    type_adhoc_desc: 'Форма буде доступна завжди',

    type_adhoc_content: 'Ця форма буде завжди доступна для заповнення',

    btn_add_schedule: 'Додати графік',
    schedules_noun: '{n} графік | {n} графік | {n} графіка',
    members_noun: '{n} член команди | {n} членів команди',

    btn_add_member: 'Додати члена команди',

    team_search_ph: 'Пошук в команді...',
    assign_ph: 'Призначити члену команди',

    copied: 'Форму скопійовано. Ви тепер редагуєте нову копію',

    delete_title:
      'Ви впевнені, що хочете <div class="del">видалити</div> форму?',
    delete_subtitle: 'Вся інформація буде втрачена.',
    delete_cancel: 'Скасувати',
    delete_confirm: 'Видалити форму',

    save_title: 'Ви бажаєте зберегти зміни?',
    save_subtitle: 'Інакше зміни буде втрачено.',
    save_cancel: 'Не зберігати',
    save_confirm: 'Зберегти зміни',
  },

  checklist_toolbar: {
    text: 'Текст',
    divider: 'Розділювач',
    image: 'Картинка',
    document: 'Файл',
    checklist: 'Чек-ліст',
    input: 'Текстове поле',
    number: 'Числове поле',
    options: 'Опції',
    file: 'Завантаження файлу',
  },

  checklist_blocks: {
    title_ph: 'Назва',
    text: {
      btn_save: 'Зберегти',
    },
    input: {
      title: 'Текстове поле',
      ph: '',
    },
    file: {
      title: 'Прикріплення файлу',
    },
    options: {
      title: 'Опції',
      item_ph: 'Опція',
      btn_add: 'Додати опцію',
      display_as: 'Показувати як',
      as_dropdown: 'Випадаючий список',
      as_buttons: 'Кнопки',
      score_ph: 'Бали',
    },
    checklist: {
      title: 'Чек-ліст',
      btn_add: 'Додати пункт',
      item_ph: 'Пункт чекліста',

      setting_required: 'Всі пункти цього чекліста мають бути виконані',
      setting_comment:
        'Вимагати коментар якщо пункт відмічається як невиконаний',
      setting_addable: 'Надати можливість користувачам додавати власні пункти',
    },
    number: {
      title: 'Числове поле',
      subtitle: 'Для вводу грошових сум, маси, температури...',
      prefix_title: 'Префікс / суфікс',
      prefix_desc: 'Ви можете додати символи перед значенням числа',
      number_ph: 'Число',
      prefix_ph: 'Префікс',
      suffix_ph: 'Суфікс',

      range_title: 'Допустимі значення',
      range_desc:
        'Ви можете вказати мінімальне та максимальне значення для цього поля',
      range_min: 'Мін',
      range_max: 'Макс',
    },
    settings: {
      required: `Обов'язково`,
      required_desc: `Для виконання форми всі обов'язкові поля мають бути заповенні`,

      scores: 'Бали',
      scores_desc:
        'Вкажіть вартість кожної опції в балах, яка потім буде сумуватись',

      cached: 'Зберігати останнє значення',

      assign_title: 'Приєднати до опції',
      assign_add: 'Додати опцію',
      assign_search: 'Пошук опцій',
    },
  },
  checklist_schedule: {
    type_scheduled: 'Плановий',
    type_repeat: 'Повтор',

    from: 'Від',
    to: 'До',

    save: 'Зберегти',

    start_date: 'Дата',
    start_time: 'Час початку',
    end_time: 'Час кінця',

    repeatable: 'Повторювати',
    repeat_every: 'Повторювати кожні',

    day: 'День',
    week: 'Тиждень',
    month: 'Місяць',
    year: 'Рік',

    weekday_names: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
    month_names: [
      'січень',
      'лютий',
      'березень',
      'квітень',
      'травень',
      'червень',
      'липень',
      'серпень',
      'вересень',
      'жовтень',
      'листопад',
      'грудень',
    ],
  },
  checklist_report_blocks: {
    required: `Обов'язково`,

    value_ph: 'Значення',

    score: 'Бали',
    completed: 'Виконано',
    uncompleted: 'Не виконано',
    not_applicable: 'Не застосовується',

    no_file: 'Файл відсутній',
  },
  checklist_reports: {
    completeness: 'Виконано',
    scheduled: 'Планова',
    expired: 'Прострочена',
    total_score: 'Всього балів',
    report_time: 'Час відправки',
    none_score: 'Немає',
    checklist_stats: 'Виконані чеклісти',

    completeness_hint: `Вираховується на основі обов'язкових секцій форми`,

    empty_title: 'Звітів не знайдено',
    empty_subtitle: 'за вибраними датами',
  },
  reserve_deposit_settings: {
    title: 'Депозит бронювання',
    subtitle:
      'Вашим гостям потрібно буде оплатити депозит для підтвердження бронювання',
    mode_full: 'Загальна вартість замовлених послуг',
    mode_constant: 'Фіксований розмір депозиту',
    mode_percent: 'Відсоток від вартості замовлених послуг',
  },
  phone_confirmation_panel: {
    title: 'Перевірка номера телефону',
    subtitle: 'Ми перевірятимемо номер телефону гостя за допомогою SMS',
    warning:
      'Це платна послуга. Перейдіть до налаштувань SMS, щоб ознайомитись з тарифами',
    more: 'Подробиці',
  },
  iiko_auto_settings: {
    online_title: 'Автоматично закривати замовлення, сплачені онлайн',
    online_subtitle:
      'Ця опція автоматично закриватиме замовлення в iiko, якщо воно було сплачене онлайн',

    select_counterparty:
      "Обреіть контрагента, на ім'я якого потрібно проводити оплату",
    none: '-- без контрагента --',
  },
  auto_accept: {
    title: 'Автоматичне прийняття замовлень',
    subtitle: `Ви можете обрати офіціанта, на ім'я якого всі замовлення будуть прийматись автоматично`,

    select_ph: '-- оберіть офіціанта --',
  },
  public_beta: {
    title: 'Menu App 2.0',
    desc:
      'Спробуйте свіжий, зручний дизайн з плавною навігацією та інноваційними функціями. Щоб спробувати, просто ввімкніть цю опцію. Не соромтеся поділитися відгуками, щоб допомогти нам поліпшити досвід користувача. Ви можете повернутися до попереднього інтерфейсу в будь-який час, вимкнувши цю опцію. Насолоджуйтесь вивченням нового інтерфейсу!',
    feedback: 'Будемо вдячні почути відгуки щодо нового інтерфейсу',
    supported_in: 'Наразі новий інтерфейс підтримується у системах',
  },
  billing_company_details: {
    title: 'Деталі компанії',
    subtitle:
      'Заповніть свої дані, щоб отримувати рахунки за підписку на QRWaiter.',

    type: 'Тип компанії',
    name: 'Назва компанії',
    vat_id: 'ЄДРПОУ',
    address: 'Адреса компанії',
    delivery_address: 'Адреса доставки документів',

    sp: 'ФОП',
    llc: 'ТОВ',
  },
  billing_reminders_panel: {
    title: 'Нагадування про продовження підписки',
    subtitle:
      'Введіть одну або кілька адрес електронної пошти, щоб ваш бухгалтер або інші співробітники також отримували нагадування за 3 дні до закінчення терміну підписки. Якщо ви оплачуєте підписку банківським переказом, рахунок на оплату буде також відправлено на вказані адреси електронної пошти.',

    list: 'Адреси електронної пошти для нагадувань',
    add: 'Додати адресу',
  },
  select_plan_modal: {
    title: 'Тарифний план',
    subtitle: 'Виберіть план, який відповідає потребам вашого бізнесу.',
    monthly: 'Щомісяця',
    annually: 'Щорічно',
    most_popular: 'НАЙПОПУЛЯРНІШИЙ',

    month: 'місяць',
    year: 'рік',

    selected: 'ВИБРАНИЙ ПЛАН',
    select: 'ВИБРАТИ ПЛАН',

    plan: 'План',

    cancel: 'Скасувати',
    confirm: 'Підтвердити',
    summary: 'Усього',

    autocancel_hint:
      'Увага: при зміні тарифного плану Ваш автоплатіж буде скасовано. Для відновлення автоматичної сплати за підписку QRWaiter, будь-ласка, оформіть автоплатіж знову.',

    lite_desc:
      'План Lite пропонує просте цифрове меню через QR-код або посилання, ідеально підходить для тих, хто потребує лише базової послуги цифрового меню.',
    dynamic_desc:
      'План Dynamic надає гнучкість, дозволяючи вам вибирати та оплачувати лише ті послуги, які вам потрібні: Inside, Takeaway, Delivery',
    smart_desc:
      'План Smart є комплексним пакетом з усіма чотирма послугами, який пропонується за загальною вартістю, нижчою, ніж при виборі окремих послуг у плані Dynamic.',
  },
  pay_invoice_modal: {
    invoice: 'Рахунок',
    service: 'Послуга',
    period: 'Період',
    subscription: 'Підписка',
    sum: 'Сума',

    monthly: 'Щомісяця',
    yearly: 'Щорічно',
    total: 'Всього',
    payment_type: 'Спосіб оплати',
    by_card: 'Оплатити карткою',
    by_bank: 'Банківський переказ',

    auto_payment: 'Автоплатіж',
    ap_hint:
      'Сума буде автоматично списуватися з вашої картки щоразу під час оплати',

    pay_now: 'Сплатити зараз',

    bank: 'Банк',
    recipient: 'Отримувач',
    payment_description: 'Опис платежу',
    description_ph: 'Оплата за рахунком',
    warning:
      'Будь ласка, збережіть такий же опис платежу, щоб наша система могла його автоматично розпізнати. Акаунт буде активовано після отримання платежу.',
  },
  superbilling: {
    tab_plan: 'План',
    tab_details: 'Деталі та сповіщення',

    valid_till: 'Заклад дійсний до',
    pricing_plan: 'Тарифний план',
    payment_sum: 'Сума платежу',
    every_month: 'Щомісяця',
    every_year: 'Щорічно',

    free_period: 'Безкоштовний період',

    services_noun: 'послуга | послуга | послуги',
    calendar_day: '-й календарний день',

    invoices: 'Рахунки',

    invoice_id: 'Номер рахунку',
    due_date: 'Термін сплати',
    services: 'Послуги',
    sum: 'Сума',
    payment_method: 'Спосіб оплати',
    status: 'Статус',

    paid: 'Сплачено',
    unpaid: 'Не сплачено',
    refunded: 'Повернуто',

    card: 'Карта',
    bank_transfer: 'Банківський переказ',

    pay_invoice: 'Сплатити',

    change_plan: 'Змінити тарифний план',

    auto_payment: 'Автоплатіж',
    ap_status: 'Статус',
    ap_enabled: 'Увімкнено',
    ap_disable: 'Вимкнути',
    ap_card: `Прив'язана карта`,
    ap_change: 'Змінити',
    ap_next_payment: 'Наступний платіж',
    ap_attempt: '-а спроба оплати',
    ap_more: 'Детальніше',
    ap_less: 'Приховати',
    ap_warning:
      'Якщо перша спроба здійснення платежу не вдасться, ми спробуємо здійснити його ще 3 рази (по одній спробі на день). Якщо всі чотири спроби не вдаються, автоплатіж буде скасовано.',

    empty_hint: 'Виберіть правильний план для вашого бізнесу',
    empty_select: 'Вибрати план',

    next_payment: 'Наступний платіж',

    confirm_disable: 'Ви впевнені, що бажаєте скасувати авто-платіж?',
  },
  superbilling_system_card: {
    active: 'Активно',
    inactive: 'Неактивно',

    banner_title: 'Необхідно оновити тарифний план',
    banner_text:
      'Ваш поточний план не включає цю систему. Вам потрібно оновити тарифний план, щоб користуватись цією системою.',
    banner_btn: 'Оновити план',

    checklist_title: 'Перелік налаштувань',
    checklist_hint:
      'Завершіть налаштування цих функцій, щоб система запрацювала',
  },
  failed_payment_banner: {
    text: 'Оплата не вдалась. Будь-ласка, оновіть ваші платіжні дані.',
    btn: 'Оновити платіжні дані',
  },
  disable_system_modal: {
    title: 'Відключення системи',
    question: 'Як ви хочете включити систему наступного разу?',
    mode_manual: 'Вручну',
    mode_auto: 'Автоматично в обрану дату',

    auto_date: 'Коли система має увімкнутися?',

    hint_manual: 'Система буде відключена, доки ви не включите її вручну',
    hint_auto: 'Система автоматично включиться в ',

    confirm_btn: 'Підтвердити',

    preliminary_title: 'Попередні замовлення, поки система вимкнена',
    preliminary_desc:
      'Ваші гості зможуть робити попереднє замовлення на той час, коли система буде доступна знову. Таким чином, ви можете збирати попередні замовлення завчасно.',
  },
  tips_settings: {
    title: 'Чайові',
    subtitle: 'Функція, що буде запитувати Ваших гостей залишити чайові',
    turn_on: 'Увімкнути',
    turn_off: 'Вимкнути',
  },
  tips_mode_panel: {
    title: 'Режим чайових',
    subtitle: 'Оберіть, як Ви бажаєте, щоб працювала ця функція',

    option_corporate: 'Корпоративні',
    option_corporate_desc:
      'Чайові будуть додані до суми замовлення і будуть сплачені на Ваш рахунок разом з чеком замовлення',

    option_personal: 'Персональні',
    option_personal_desc:
      'Гості будуть залишати чайові самотужки, обираючи когось з Вашого персоналу. Чайові будуть надіслані офіціанту напряму за допомогою посилання.',
  },
  tips_merchant_panel: {
    title: 'Платіжний рахунок',
    subtitle: 'Будь-ласка, оберіть на який рахунок слід зараховувати чайові',
  },
  tips_systems_panel: {
    title: 'Системи',
    subtitle: 'Ви можете обрати системи, в яких чайові будуть працювати',
  },
  tips_team_panel: {
    title: 'Команда',
    subtitle:
      'Налаштуйте чайові для кожного члена Вашої команди, вказавши посилання для залишення чайових.',
    link: 'Посилання',
    role_ph: 'Офіціант',
  },
  request_integration: {
    btn: 'Запросити інтеграцію',
    description:
      'Якщо Ви не знайшли потрібну Вам інтеграцію, Ви можете відправити свій запит на на її розробку. Інтеграції, на які ми отримуємо велику кількість запитів - мають пріорітет в розробці і будуть доступні якнайшвидше.',
    name_ph: 'Назва інтеграції',
    send: 'Відправити',
    success: 'Ваш запит на інтеграцію успішно відправлено',
  },
};
